(function () {
  'use strict';

  function one(selector, root) {
    return (root || document).querySelector(selector);
  }

  function all(selector, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(selector));
  }

  function number(value, fallback) {
    var parsed = parseFloat(value);
    return isFinite(parsed) ? parsed : fallback;
  }

  function clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
  }

  function money(value, symbol) {
    return symbol + value.toFixed(2);
  }

  function pixelSnap(value) {
    var ratio = window.devicePixelRatio || 1;
    return Math.round(value * ratio) / ratio;
  }

  function safeFileName(value) {
    return (value || 'selected-sign').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  }

  function coverScale(imageWidth, imageHeight, frameWidth, frameHeight) {
    return Math.max(frameWidth / imageWidth, frameHeight / imageHeight);
  }

  function movementScale(imageWidth, imageHeight, frameWidth, frameHeight, mode) {
    return coverScale(imageWidth, imageHeight, frameWidth, frameHeight);
  }

  function movementPosition(mode, cropX, cropY) {
    return {
      x: mode === 'vertical' ? .5 : cropX,
      y: mode === 'horizontal' ? .5 : cropY
    };
  }

  function movementOffset(renderedSize, frameSize, position) {
    if (renderedSize <= frameSize) return (frameSize - renderedSize) / 2;
    return -(renderedSize - frameSize) * clamp(position, 0, 1);
  }

  /* "70x84|70x84|70x84" — the separate signs the shopper ordered, in the order
     they hang. Written by the product page; read here so the cart can show the
     order the way it was bought. */
  function panelRun(container) {
    var panels = [];
    (container.getAttribute('data-panel-run') || '').split('|').forEach(function (entry) {
      var parts = entry.split('x');
      var panelWidth = number(parts[0], 0);
      var panelHeight = number(parts[1], 0);
      if (panelWidth > 0 && panelHeight > 0) panels.push({ width: panelWidth, height: panelHeight });
    });
    return panels;
  }

  /* One framed picture per panel, laid out end to end with a gap where the
     signs really stop, each showing exactly its own part of the one continuous
     mural. A shopper who ordered four signs sees four pictures. */
  function renderCropPanels(container, img, panels, view) {
    var host = one('[data-cart-panels]', container);
    if (!host) {
      host = document.createElement('div');
      host.className = 'cart-custom-crop__panels';
      host.setAttribute('data-cart-panels', '');
      container.appendChild(host);
    }
    host.replaceChildren();
    img.style.visibility = 'hidden';   /* it is the source for the copies only */
    var gap = Math.max(2, Math.round(view.boxWidth * .008));
    var runLeft = 0;
    panels.forEach(function (panel, index) {
      var pane = document.createElement('span');
      pane.className = 'cart-custom-crop__panel';
      var paneLeft = runLeft / view.width * view.boxWidth;
      var paneWidth = panel.width / view.width * view.boxWidth;
      var paneHeight = panel.height / view.height * view.boxHeight;
      pane.style.left = paneLeft + 'px';
      pane.style.top = '0px';
      pane.style.width = Math.max(1, paneWidth - (index < panels.length - 1 ? gap : 0)) + 'px';
      pane.style.height = paneHeight + 'px';
      pane.setAttribute('data-panel-label',
        'Panel ' + (index + 1) + ' · ' + cleanNumber(panel.width) + '×' + cleanNumber(panel.height) + '"');

      var copy = document.createElement('img');
      copy.src = img.currentSrc || img.src;
      copy.alt = '';
      copy.decoding = 'async';
      copy.style.position = 'absolute';
      copy.style.width = view.renderedWidth + 'px';
      copy.style.height = view.renderedHeight + 'px';
      copy.style.left = (view.offsetX - paneLeft) + 'px';
      copy.style.top = view.offsetY + 'px';
      copy.style.maxWidth = 'none';
      pane.appendChild(copy);
      host.appendChild(pane);
      runLeft += panel.width;
    });
  }

  function renderCropElement(container) {
    var img = one('img', container);
    if (!img) return;
    var width = Math.max(1, number(container.getAttribute('data-width'), 1));
    var height = Math.max(1, number(container.getAttribute('data-height'), 1));
    var cropX = clamp(number(container.getAttribute('data-crop-x'), .5), 0, 1);
    var cropY = clamp(number(container.getAttribute('data-crop-y'), .5), 0, 1);
    var cropMode = container.getAttribute('data-crop-mode') || 'cover';
    var boxWidth = container.clientWidth || 120;
    var boxHeight = Math.max(1, boxWidth * height / width);
    container.style.height = boxHeight + 'px';
    var panels = panelRun(container);

    function place() {
      if (!img.naturalWidth || !img.naturalHeight) return;
      var scale = movementScale(img.naturalWidth, img.naturalHeight, boxWidth, boxHeight, cropMode);
      var renderedWidth = img.naturalWidth * scale;
      var renderedHeight = img.naturalHeight * scale;
      var position = movementPosition(cropMode, cropX, cropY);
      var offsetX = movementOffset(renderedWidth, boxWidth, position.x);
      var offsetY = movementOffset(renderedHeight, boxHeight, position.y);
      if (panels.length > 1) {
        renderCropPanels(container, img, panels, {
          width: width, height: height, boxWidth: boxWidth, boxHeight: boxHeight,
          renderedWidth: renderedWidth, renderedHeight: renderedHeight,
          offsetX: offsetX, offsetY: offsetY
        });
        return;
      }
      img.style.width = renderedWidth + 'px';
      img.style.height = renderedHeight + 'px';
      img.style.left = offsetX + 'px';
      img.style.top = offsetY + 'px';
    }
    if (img.complete && img.naturalWidth) place();
    else img.addEventListener('load', place, { once: true });
  }

  function downloadCrop(container, button) {
    var width = Math.max(1, number(container.getAttribute('data-width'), 1));
    var height = Math.max(1, number(container.getAttribute('data-height'), 1));
    var cropX = clamp(number(container.getAttribute('data-crop-x'), .5), 0, 1);
    var cropY = clamp(number(container.getAttribute('data-crop-y'), .5), 0, 1);
    var cropMode = container.getAttribute('data-crop-mode') || 'cover';
    var source = container.getAttribute('data-download-source') || container.getAttribute('data-source');
    if (!source) return;
    var image = new Image();
    image.crossOrigin = 'anonymous';
    var originalButtonText = button ? button.innerHTML : '';
    var completed = false;
    var safetyTimer;
    if (button) {
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      button.textContent = 'Preparing your preview…';
    }

    function resetButton(message) {
      if (completed) return;
      completed = true;
      window.clearTimeout(safetyTimer);
      if (!button) return;
      button.disabled = false;
      button.removeAttribute('aria-busy');
      if (message) {
        button.textContent = message;
        window.setTimeout(function () { button.innerHTML = originalButtonText; }, 2200);
      } else {
        button.innerHTML = originalButtonText;
      }
    }

    safetyTimer = window.setTimeout(function () {
      resetButton('Could not prepare preview — please try again');
    }, 15000);

    function finishDownload() {
      var maxOutput = window.innerWidth <= 767 ? 900 : 1200;
      var outputWidth = maxOutput;
      var outputHeight = Math.max(1, Math.round(outputWidth * height / width));
      if (outputHeight > maxOutput) {
        outputHeight = maxOutput;
        outputWidth = Math.max(1, Math.round(outputHeight * width / height));
      }
      /* A split order downloads as one unbroken picture with the cut lines
         drawn on it, so the shopper sees the whole thing exactly as it will
         look on the walls and can still tell where each sign ends. */
      var panels = panelRun(container);
      var split = panels.length > 1;
      var gapPixels = 0;
      var canvas = document.createElement('canvas');
      canvas.width = outputWidth;
      canvas.height = outputHeight;
      var context = canvas.getContext('2d', { alpha: false });
      if (!context) {
        resetButton('Could not prepare preview — please try again');
        return;
      }
      context.fillStyle = '#ffffff';
      context.fillRect(0, 0, canvas.width, canvas.height);
      var scale = movementScale(image.naturalWidth, image.naturalHeight, outputWidth, outputHeight, cropMode);
      var renderedWidth = image.naturalWidth * scale;
      var renderedHeight = image.naturalHeight * scale;
      var position = movementPosition(cropMode, cropX, cropY);
      var offsetX = movementOffset(renderedWidth, outputWidth, position.x);
      var offsetY = movementOffset(renderedHeight, outputHeight, position.y);

      context.drawImage(image, offsetX, offsetY, renderedWidth, renderedHeight);

      var frames = [];
      if (split) {
        var runLeft = 0;
        panels.forEach(function (panel, index) {
          var panelLeft = runLeft / width * outputWidth;
          var panelWidth = panel.width / width * outputWidth;
          var panelHeight = panel.height / height * outputHeight;
          /* A sign shorter than the tallest one prints less at the bottom, so
             the part it never gets is cleared rather than shown. */
          if (panelHeight < outputHeight - 1) {
            context.fillStyle = '#ffffff';
            context.fillRect(panelLeft, panelHeight, panelWidth, outputHeight - panelHeight);
          }
          frames.push({
            x: panelLeft, y: 0, width: panelWidth, height: panelHeight,
            label: 'Panel ' + (index + 1) + ' \u00b7 ' + cleanNumber(panel.width) + ' \u00d7 ' + cleanNumber(panel.height) + ' in'
          });
          runLeft += panel.width;
        });
      }
      var outputWidthWithGaps = canvas.width;

      /* Protect downloadable previews with a repeated Creative Sukkah watermark. */
      var watermarkSize = Math.max(18, Math.round(Math.min(outputWidthWithGaps, outputHeight) * .055));
      var watermarkStepX = Math.max(180, watermarkSize * 8);
      var watermarkStepY = Math.max(100, watermarkSize * 4.5);
      context.save();
      context.translate(outputWidthWithGaps / 2, outputHeight / 2);
      context.rotate(-Math.PI / 7);
      context.translate(-outputWidthWithGaps / 2, -outputHeight / 2);
      context.font = '700 ' + watermarkSize + 'px Arial, sans-serif';
      context.textAlign = 'center';
      context.textBaseline = 'middle';
      context.fillStyle = 'rgba(255,255,255,.48)';
      context.strokeStyle = 'rgba(45,28,20,.32)';
      context.lineWidth = Math.max(1, watermarkSize * .055);
      for (var watermarkY = -outputHeight; watermarkY < outputHeight * 2; watermarkY += watermarkStepY) {
        for (var watermarkX = -outputWidthWithGaps; watermarkX < outputWidthWithGaps * 2; watermarkX += watermarkStepX) {
          context.strokeText('Creative Sukkah', watermarkX, watermarkY);
          context.fillText('Creative Sukkah', watermarkX, watermarkY);
        }
      }
      context.restore();

      /* The cut marks, drawn last so the watermark cannot hide them: an outline
         round every panel, a dashed line down the middle of each gap where the
         two signs part, and each panel's own finished size. */
      if (split) {
        var markSize = Math.max(11, Math.round(outputHeight * .026));
        context.font = '700 ' + markSize + 'px Arial, sans-serif';
        context.textAlign = 'left';
        context.textBaseline = 'top';
        frames.forEach(function (frame, index) {
          context.lineWidth = Math.max(2, Math.round(outputHeight * .004));
          context.strokeStyle = 'rgba(24,18,12,.9)';
          context.setLineDash([]);
          context.strokeRect(frame.x, frame.y, frame.width, frame.height);

          if (index < frames.length - 1) {
            var cutX = frame.x + frame.width + gapPixels / 2;   /* the seam itself when there is no gap */
            context.save();
            context.setLineDash([Math.max(6, markSize * .7), Math.max(5, markSize * .6)]);
            context.lineWidth = Math.max(1, Math.round(outputHeight * .0025));
            context.strokeStyle = 'rgba(24,18,12,.75)';
            context.beginPath();
            context.moveTo(cutX, 0);
            context.lineTo(cutX, outputHeight);
            context.stroke();
            context.restore();
          }

          var padding = Math.round(markSize * .45);
          var textWidth = context.measureText(frame.label).width;
          context.fillStyle = 'rgba(24,18,12,.86)';
          context.fillRect(frame.x, frame.y, textWidth + padding * 2, markSize + padding * 2);
          context.fillStyle = '#ffffff';
          context.fillText(frame.label, frame.x + padding, frame.y + padding);
        });
      }
      try {
        canvas.toBlob(function (blob) {
          if (!blob) {
            resetButton('Could not prepare preview — please try again');
            return;
          }
          var link = document.createElement('a');
          var objectUrl = URL.createObjectURL(blob);
          link.download = safeFileName(container.getAttribute('data-title')) + '-' + width + 'x' + height + '-watermarked-preview.jpg';
          link.href = objectUrl;
          link.target = '_blank';
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.setTimeout(function () { URL.revokeObjectURL(objectUrl); }, 5000);
          canvas.width = 1;
          canvas.height = 1;
          resetButton();
        }, 'image/jpeg', .76);
      } catch (problem) {
        canvas.width = 1;
        canvas.height = 1;
        resetButton('Could not prepare preview — please try again');
      }
    }

    function startDownload() {
      window.requestAnimationFrame(function () {
        window.setTimeout(finishDownload, 0);
      });
    }

    image.onload = startDownload;
    image.onerror = function () { resetButton('Could not load preview — please try again'); };
    image.src = source;
  }

  var cartCropContainers = document.querySelectorAll('[data-cart-crop]');
  cartCropContainers.forEach(function (container) {
    renderCropElement(container);
    var item = container.closest('.w-commerce-commercecartitem');
    var download = item && one('[data-download-cart-crop]', item);
    if (download) download.addEventListener('click', function () { downloadCrop(container, download); });
  });
  if (cartCropContainers.length) {
    var cartResizeTimer;
    window.addEventListener('resize', function () {
      window.clearTimeout(cartResizeTimer);
      cartResizeTimer = window.setTimeout(function () {
        cartCropContainers.forEach(renderCropElement);
      }, 100);
    });
  }

  document.querySelectorAll('[data-remove-design]').forEach(function (removeButton) {
    removeButton.addEventListener('click', function () {
      var designId = removeButton.getAttribute('data-remove-design');
      if (!designId) return;
      removeButton.disabled = true;
      fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart.js', {
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json' }
      })
        .then(function (response) { return response.json(); })
        .then(function (cart) {
          var updates = {};
          cart.items.forEach(function (item) {
            if (item.properties && item.properties['_Design ID'] === designId) updates[item.key] = 0;
          });
          return fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/update.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates: updates })
          });
        })
        .then(function (response) {
          if (!response.ok) throw new Error('Could not remove customized sign');
          window.location.reload();
        })
        .catch(function () {
          removeButton.disabled = false;
        });
    });
  });

  document.querySelectorAll('[data-edit-customization]').forEach(function (editLink) {
    editLink.addEventListener('click', function (event) {
      event.preventDefault();
      var designId = editLink.getAttribute('data-edit-customization');
      if (!designId) { window.location.assign(editLink.href); return; }
      var originalText = editLink.textContent;
      editLink.textContent = 'Opening saved customization…';
      fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart.js', {
        credentials: 'same-origin', headers: { 'Accept': 'application/json' }
      })
        .then(function (response) { return response.json(); })
        .then(function (cart) {
          var item = cart.items.find(function (cartItem) {
            return cartItem.properties && cartItem.properties['_Design ID'] === designId && !cartItem.properties['_Charge type'];
          });
          if (!item) throw new Error('Saved customization not found');
          var editState = {
            designId: designId,
            variantId: item.variant_id,
            properties: item.properties || {}
          };
          window.sessionStorage.setItem('creativeSukkahEdit:' + designId, JSON.stringify(editState));
          var destination = new URL(editLink.href, window.location.origin);
          destination.searchParams.set('edit_design', designId);
          window.location.assign(destination.href);
        })
        .catch(function () {
          editLink.textContent = originalText;
          window.location.assign(editLink.href);
        });
    });
  });

  document.querySelectorAll('[data-customizer-link]').forEach(function (link) {
    link.addEventListener('click', function (event) {
      event.preventDefault();
      if (link.getAttribute('aria-disabled') === 'true') return;
      window.location.assign(link.href);
    });
  });

  var root = one('[data-sign-customizer]');
  if (!root) return;

  var editState = null;
  var editDesignParam = new URLSearchParams(window.location.search).get('edit_design');
  if (editDesignParam) {
    try {
      editState = JSON.parse(window.sessionStorage.getItem('creativeSukkahEdit:' + editDesignParam) || 'null');
      if (!editState || editState.designId !== editDesignParam) editState = null;
    } catch (editStateProblem) {
      editState = null;
    }
  }

  var viewport = one('[data-crop-viewport]', root);
  var image = one('[data-crop-image]', root);
  var contextPreview = one('[data-crop-context]', root);
  var contextImage = one('[data-context-image]', root);
  var contextSelection = one('[data-context-selection]', root);
  var widthInput = one('[data-sign-width]', root);
  var heightInput = one('[data-sign-height]', root);
  var panelCountButtons = all('[data-panel-count]', root);
  var panelRows = all('[data-panel-row]', root);
  var panelWidthInputs = all('[data-panel-width]', root);
  var panelHeightInputs = all('[data-panel-height]', root);
  var panelWidthPopups = all('[data-panel-width-popup]', root);
  var panelStatuses = all('[data-panel-status]', root);
  var panelPopupTimers = [];
  var panelGuides = one('[data-panel-guides]', root);
  var panelCount = 1;
  var sizeUnitButtons = all('[data-size-unit]', root);
  var sizeUnitLabels = all('[data-size-unit-label]', root);
  var sizeConversion = one('[data-size-conversion]', root);
  var grommets = one('[data-sign-grommets]', root);
  var form = document.getElementById('sign-product-form');
  var button = one('[data-add-customization]', root);
  var error = one('[data-customizer-error]', root);
  var confirmation = one('[data-sign-confirm]', root);
  var confirmationImage = one('[data-sign-confirm-image]', root);
  var confirmationMessage = one('[data-sign-confirm-message]', root);
  var confirmationMeasurements = one('[data-sign-confirm-measurements]', root);
  var confirmationDialog = one('[data-sign-confirm-dialog]', root);
  var confirmationObjectUrl = '';
  var confirmationAccepted = false;
  var preparedProofFiles = null;
  var preparingProofsPromise = null;
  var uploadEnabled = root.getAttribute('data-customer-upload-enabled') === 'true';
  var uploadInput = one('[data-customer-artwork]', root);
  var uploadFileLabel = one('[data-upload-file]', root);
  var qualityPanel = one('[data-image-quality]', root);
  var uploadedObjectUrl = '';
  var uploadedFile = null;
  var existingCustomerArtworkUrl = '';
  var editingOriginalDesignId = editState ? editState.designId : '';
  var editingOriginalProperties = editState && editState.properties ? editState.properties : null;
  var pdfPreviewLoading = false;
  var currentImageQuality = '';
  var qualityWarningAccepted = false;
  var qualityWarning = one('[data-quality-warning]', root);
  var basePrice = number(root.getAttribute('data-design-fee-price-cents'), 8500) / 100;
  var squareFootPrice = number(root.getAttribute('data-square-foot-price'), 3.5);
  var grommetUnitPrice = number(root.getAttribute('data-grommet-price-cents'), 100) / 100;
  var cornerGrommetPrice = number(root.getAttribute('data-corner-grommet-price-cents'), 500) / 100;
  var symbol = root.getAttribute('data-currency-symbol') || '$';
  var cropX = .5;
  var cropY = .5;
  var activeSizeUnit = 'inches';
  var singlePanelSize = { width: number(panelWidthInputs[0].value, 96), height: number(panelHeightInputs[0].value, 48) };
  var splitPanelSizes = [
    { width: '', height: '' }, { width: '', height: '' },
    { width: '', height: '' }, { width: '', height: '' }
  ];
  var activeMovement = 'horizontal';
  var dragging = false;
  var contextDragging = false;
  var lastX = 0;
  var lastY = 0;
  var updating = false;
  var lastViewportWidth = 0;
  var lastViewportHeight = 0;
  var stableWindowHeight = window.innerHeight;
  var lastWindowWidth = window.innerWidth;
  var lastWindowHeight = window.innerHeight;
  var resizeFrame = 0;

  function removeOriginalEditedDesign() {
    if (!editingOriginalDesignId) return Promise.resolve(null);
    return fetch(window.theme.routes.cart + '.js', {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('The previous customized sign could not be found.');
      return response.json();
    }).then(function (cart) {
      var updates = {};
      (cart.items || []).forEach(function (item) {
        if (item.properties && item.properties['_Design ID'] === editingOriginalDesignId) {
          updates[item.key] = 0;
        }
      });
      if (!Object.keys(updates).length) return cart;
      return fetch(window.theme.routes.cartUpdate + '.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates })
      }).then(function (response) {
        if (!response.ok) throw new Error('The old customized sign could not be replaced. Please review your cart.');
        return response.json();
      });
    });
  }

  /* Keep the fixed confirmation above the footer and every theme section.
     A fixed element left inside the customizer's stacking context can be
     painted underneath later sections in some Shopify themes. */
  if (confirmation && confirmation.parentNode !== document.body) {
    document.body.appendChild(confirmation);
  }

  /* Create two proofs from the exact same crop. The public customer proof is
     intentionally small and watermarked. The private production proof is
     uploaded under an underscore-prefixed line-item property so Shopify keeps
     it visible to staff in Orders but hides it from customer-facing areas. */
  function createCroppedPreviewFile(options) {
    options = options || {};
    return new Promise(function (resolve, reject) {
      function createFile() {
        if (!image.naturalWidth || !image.naturalHeight) {
          reject(new Error('The artwork has not finished loading. Please wait a moment and try again.'));
          return;
        }
        var size = dimensions();
        var ratio = size.width / size.height;
        var maxSide = options.maxSide || 1800;
        var borderInches = Math.max(0, number(options.borderInches, 0));
        var borderPixels = 0;
        var contentWidth;
        var contentHeight;
        var outputWidth;
        var outputHeight;
        if (borderInches > 0) {
          /* Keep the black trim border outside the customer's finished size.
             Its pixel width is proportional to one physical inch. */
          var pixelsPerInch = maxSide / Math.max(size.width + borderInches * 2, size.height + borderInches * 2);
          borderPixels = Math.max(1, Math.round(borderInches * pixelsPerInch));
          contentWidth = Math.max(1, Math.round(size.width * pixelsPerInch));
          contentHeight = Math.max(1, Math.round(size.height * pixelsPerInch));
          outputWidth = contentWidth + borderPixels * 2;
          outputHeight = contentHeight + borderPixels * 2;
        } else {
          outputWidth = ratio >= 1 ? maxSide : Math.max(1, Math.round(maxSide * ratio));
          outputHeight = ratio >= 1 ? Math.max(1, Math.round(maxSide / ratio)) : maxSide;
          contentWidth = outputWidth;
          contentHeight = outputHeight;
        }
        var canvas = document.createElement('canvas');
        canvas.width = outputWidth;
        canvas.height = outputHeight;
        var context = canvas.getContext('2d', { alpha: false });
        if (!context) {
          reject(new Error('The cropped preview could not be created. Please try again.'));
          return;
        }
        context.fillStyle = borderInches > 0 ? '#000000' : '#ffffff';
        context.fillRect(0, 0, outputWidth, outputHeight);
        var scale = movementScale(image.naturalWidth, image.naturalHeight, contentWidth, contentHeight, activeMovement);
        var renderedWidth = image.naturalWidth * scale;
        var renderedHeight = image.naturalHeight * scale;
        var position = movementPosition(activeMovement, cropX, cropY);
        var offsetX = borderPixels + movementOffset(renderedWidth, contentWidth, position.x);
        var offsetY = borderPixels + movementOffset(renderedHeight, contentHeight, position.y);
        try {
          context.drawImage(image, offsetX, offsetY, renderedWidth, renderedHeight);
          if (options.watermark) {
            var watermarkSize = Math.max(18, Math.round(Math.min(outputWidth, outputHeight) * .065));
            var watermarkStepX = Math.max(170, watermarkSize * 7.5);
            var watermarkStepY = Math.max(90, watermarkSize * 4.2);
            context.save();
            context.translate(outputWidth / 2, outputHeight / 2);
            context.rotate(-Math.PI / 7);
            context.translate(-outputWidth / 2, -outputHeight / 2);
            context.font = '700 ' + watermarkSize + 'px Arial, sans-serif';
            context.textAlign = 'center';
            context.textBaseline = 'middle';
            context.fillStyle = 'rgba(255,255,255,.46)';
            context.strokeStyle = 'rgba(0,0,0,.28)';
            context.lineWidth = Math.max(1, watermarkSize * .06);
            for (var watermarkY = -outputHeight; watermarkY < outputHeight * 2; watermarkY += watermarkStepY) {
              for (var watermarkX = -outputWidth; watermarkX < outputWidth * 2; watermarkX += watermarkStepX) {
                context.strokeText('Creative Sukkah', watermarkX, watermarkY);
                context.fillText('Creative Sukkah', watermarkX, watermarkY);
              }
            }
            context.restore();
          }
          canvas.toBlob(function (blob) {
            if (!blob) {
              reject(new Error('The cropped preview could not be created. Please try again.'));
              return;
            }
            var designField = one('[data-property-design-id]', root);
            var designName = designField && designField.value ? designField.value : Date.now().toString(36);
            var title = safeFileName(root.getAttribute('data-product-title') || 'custom-sign');
            var measurementName = cleanNumber(size.width) + 'x' + cleanNumber(size.height) + '-inches';
            var fileLabel = options.fileLabel || 'cropped-preview';
            resolve(new File([blob], title + '-' + measurementName + '-' + designName + '-' + fileLabel + '.jpg', { type: 'image/jpeg' }));
          }, 'image/jpeg', options.quality || .9);
        } catch (problem) {
          reject(new Error('The cropped preview could not be created. Please refresh the page and try again.'));
        }
      }
      if (image.complete && image.naturalWidth) createFile();
      else {
        image.addEventListener('load', createFile, { once: true });
        image.addEventListener('error', function () {
          reject(new Error('The artwork could not be loaded. Please refresh the page and try again.'));
        }, { once: true });
      }
    });
  }

  /* ---- the separate signs, as files ------------------------------------

     Everything below cuts the one continuous picture into the panels that were
     ordered. The rectangles are measured on the picture the page is showing,
     then scaled onto the largest copy Shopify will render, so the printer gets
     every pixel the artwork has rather than the small on-screen copy. */

  var printImage = null;
  var printImagePromise = null;

  function loadPrintImage() {
    if (printImagePromise) return printImagePromise;
    var url = root.getAttribute('data-image-url') || '';
    if (!url || (uploadEnabled && uploadedObjectUrl)) {
      printImagePromise = Promise.resolve(null);
      return printImagePromise;
    }
    printImagePromise = new Promise(function (resolve) {
      var candidate = new Image();
      candidate.crossOrigin = 'anonymous';
      candidate.onload = function () { printImage = candidate; resolve(candidate); };
      candidate.onerror = function () { resolve(null); };
      candidate.src = url;
    });
    return printImagePromise;
  }

  function printSource() {
    if (uploadEnabled && uploadedObjectUrl) return image;
    if (printImage && printImage.naturalWidth > image.naturalWidth) return printImage;
    return image;
  }

  function printScale(source) {
    if (!image.naturalWidth || !source.naturalWidth) return 1;
    return source.naturalWidth / image.naturalWidth;
  }

  /* The part of the artwork the whole run covers, in source pixels. */
  function selectedSourceCrop(size) {
    var targetRatio = size.width / size.height;
    var sourceRatio = image.naturalWidth / image.naturalHeight;
    var sourceWidth;
    var sourceHeight;
    var sourceX;
    var sourceY;
    if (sourceRatio > targetRatio) {
      sourceHeight = image.naturalHeight;
      sourceWidth = sourceHeight * targetRatio;
      sourceX = (image.naturalWidth - sourceWidth) * cropX;
      sourceY = 0;
    } else {
      sourceWidth = image.naturalWidth;
      sourceHeight = sourceWidth / targetRatio;
      sourceX = 0;
      sourceY = (image.naturalHeight - sourceHeight) * cropY;
    }
    return { x: sourceX, y: sourceY, width: sourceWidth, height: sourceHeight };
  }

  /* One panel's share of that, so panel 2 starts exactly where panel 1 ends. */
  function panelSourceCrop(size, panelIndex) {
    var master = selectedSourceCrop(size);
    var startWidth = 0;
    for (var index = 0; index < panelIndex; index += 1) startWidth += size.panels[index].width;
    var panel = size.panels[panelIndex];
    return {
      x: master.x + master.width * startWidth / size.width,
      y: master.y,
      width: master.width * panel.width / size.width,
      height: master.height * panel.height / size.height
    };
  }

  function addProofWatermark(canvas, context) {
    var watermarkSize = Math.max(18, Math.round(Math.min(canvas.width, canvas.height) * .055));
    var stepX = Math.max(170, watermarkSize * 7.5);
    var stepY = Math.max(90, watermarkSize * 4.2);
    context.save();
    context.translate(canvas.width / 2, canvas.height / 2);
    context.rotate(-Math.PI / 7);
    context.translate(-canvas.width / 2, -canvas.height / 2);
    context.font = '700 ' + watermarkSize + 'px Arial, sans-serif';
    context.textAlign = 'center';
    context.textBaseline = 'middle';
    context.fillStyle = 'rgba(255,255,255,.46)';
    context.strokeStyle = 'rgba(0,0,0,.28)';
    context.lineWidth = Math.max(1, watermarkSize * .06);
    for (var y = -canvas.height; y < canvas.height * 2; y += stepY) {
      for (var x = -canvas.width; x < canvas.width * 2; x += stepX) {
        context.strokeText('Creative Sukkah', x, y);
        context.fillText('Creative Sukkah', x, y);
      }
    }
    context.restore();
  }

  function canvasFile(canvas, fileLabel, quality) {
    return new Promise(function (resolve, reject) {
      canvas.toBlob(function (blob) {
        if (!blob) {
          reject(new Error('The production files could not be created. Please try again.'));
          return;
        }
        var designField = one('[data-property-design-id]', root);
        var designName = designField && designField.value ? designField.value : Date.now().toString(36);
        var title = safeFileName(root.getAttribute('data-product-title') || 'custom-sign');
        resolve(new File([blob], title + '-' + designName + '-' + fileLabel + '.jpg', { type: 'image/jpeg' }));
      }, 'image/jpeg', quality || .9);
    });
  }

  /* All the panels side by side with a gap and a cut line between them: what
     the shopper sees, and what shows the split at a glance. */
  function createPanelOverviewFile(options) {
    options = options || {};
    var size = dimensions();
    var borderInches = Math.max(0, number(options.borderInches, 0));
    /* An explicit 0 means the panels butt together and the cut lines alone
       show where each sign ends. */
    var gapInches = size.panelCount > 1 ? Math.max(0, number(options.gapInches, .5)) : 0;
    var physicalWidth = size.panels.reduce(function (total, panel) {
      return total + panel.width + borderInches * 2;
    }, 0) + gapInches * Math.max(0, size.panelCount - 1);
    var physicalHeight = size.panels.reduce(function (maximum, panel) {
      return Math.max(maximum, panel.height + borderInches * 2);
    }, 1);
    var pixelsPerInch = (options.maxSide || 1800) / Math.max(physicalWidth, physicalHeight);
    var canvas = document.createElement('canvas');
    canvas.width = Math.max(1, Math.round(physicalWidth * pixelsPerInch));
    canvas.height = Math.max(1, Math.round(physicalHeight * pixelsPerInch));
    var context = canvas.getContext('2d', { alpha: false });
    if (!context) return Promise.reject(new Error('The panel preview could not be created.'));
    context.fillStyle = '#ffffff';
    context.fillRect(0, 0, canvas.width, canvas.height);
    var art = printSource();
    var factor = printScale(art);
    var destinationX = 0;
    var frames = [];
    size.panels.forEach(function (panel, index) {
      var borderPixels = Math.max(0, Math.round(borderInches * pixelsPerInch));
      var panelWidthPixels = Math.max(1, Math.round(panel.width * pixelsPerInch));
      var panelHeightPixels = Math.max(1, Math.round(panel.height * pixelsPerInch));
      if (borderPixels) {
        context.fillStyle = '#000000';
        context.fillRect(destinationX, 0, panelWidthPixels + borderPixels * 2, panelHeightPixels + borderPixels * 2);
      }
      var source = panelSourceCrop(size, index);
      context.drawImage(art,
        source.x * factor, source.y * factor, source.width * factor, source.height * factor,
        destinationX + borderPixels, borderPixels, panelWidthPixels, panelHeightPixels);
      frames.push({
        x: destinationX + borderPixels, y: borderPixels,
        width: panelWidthPixels, height: panelHeightPixels,
        label: 'Panel ' + (index + 1) + ' \u00b7 ' + cleanNumber(panel.width) + ' \u00d7 ' + cleanNumber(panel.height) + ' in'
      });
      destinationX += panelWidthPixels + borderPixels * 2 + Math.round(gapInches * pixelsPerInch);
    });
    if (options.watermark) addProofWatermark(canvas, context);
    if (options.cutMarks && size.panelCount > 1) drawCutMarks(context, canvas, frames, Math.round(gapInches * pixelsPerInch));
    return canvasFile(canvas, options.fileLabel || 'panel-overview', options.quality || .9);
  }

  /* Drawn last so the watermark cannot hide them: an outline round every
     panel, its finished size, and a dashed line down each gap. */
  function drawCutMarks(context, canvas, frames, gapPixels) {
    var markSize = Math.max(11, Math.round(canvas.height * .026));
    context.font = '700 ' + markSize + 'px Arial, sans-serif';
    context.textAlign = 'left';
    context.textBaseline = 'top';
    frames.forEach(function (frame, index) {
      context.setLineDash([]);
      context.lineWidth = Math.max(2, Math.round(canvas.height * .004));
      context.strokeStyle = 'rgba(24,18,12,.9)';
      context.strokeRect(frame.x, frame.y, frame.width, frame.height);
      if (index < frames.length - 1) {
        var cutX = frame.x + frame.width + gapPixels / 2;
        context.save();
        context.setLineDash([Math.max(6, markSize * .7), Math.max(5, markSize * .6)]);
        context.lineWidth = Math.max(1, Math.round(canvas.height * .0025));
        context.strokeStyle = 'rgba(24,18,12,.75)';
        context.beginPath();
        context.moveTo(cutX, 0);
        context.lineTo(cutX, canvas.height);
        context.stroke();
        context.restore();
      }
      var padding = Math.round(markSize * .45);
      var textWidth = context.measureText(frame.label).width;
      context.fillStyle = 'rgba(24,18,12,.86)';
      context.fillRect(frame.x, frame.y, textWidth + padding * 2, markSize + padding * 2);
      context.fillStyle = '#ffffff';
      context.fillText(frame.label, frame.x + padding, frame.y + padding);
    });
  }

  /* One panel on its own, at print size, inside a 1 inch black trim border. */
  function createPanelProductionFile(panelIndex, options) {
    options = options || {};
    var size = dimensions();
    var panel = size.panels[panelIndex];
    var borderInches = 1;
    var maxSide = options.maxSide || 2200;
    var pixelsPerInch = maxSide / Math.max(panel.width + borderInches * 2, panel.height + borderInches * 2);
    var borderPixels = Math.max(1, Math.round(borderInches * pixelsPerInch));
    var contentWidth = Math.max(1, Math.round(panel.width * pixelsPerInch));
    var contentHeight = Math.max(1, Math.round(panel.height * pixelsPerInch));
    var canvas = document.createElement('canvas');
    canvas.width = contentWidth + borderPixels * 2;
    canvas.height = contentHeight + borderPixels * 2;
    var context = canvas.getContext('2d', { alpha: false });
    if (!context) return Promise.reject(new Error('A clear panel file could not be created.'));
    context.fillStyle = '#000000';
    context.fillRect(0, 0, canvas.width, canvas.height);
    var source = panelSourceCrop(size, panelIndex);
    var art = printSource();
    var factor = printScale(art);
    context.drawImage(art,
      source.x * factor, source.y * factor, source.width * factor, source.height * factor,
      borderPixels, borderPixels, contentWidth, contentHeight);
    return canvasFile(canvas,
      'CLEAR-panel-' + (panelIndex + 1) + '-' + cleanNumber(panel.width) + 'x' + cleanNumber(panel.height) + 'in-1in-black-border',
      options.quality || .86);
  }


  function sourceCropPixels(size) {
    if (!image.naturalWidth || !image.naturalHeight) return { width: 0, height: 0 };
    var targetRatio = size.width / size.height;
    var sourceRatio = image.naturalWidth / image.naturalHeight;
    if (sourceRatio > targetRatio) {
      return { width: image.naturalHeight * targetRatio, height: image.naturalHeight };
    }
    return { width: image.naturalWidth, height: image.naturalWidth / targetRatio };
  }

  function updateImageQuality(size) {
    if (!uploadEnabled || !qualityPanel || !uploadedFile || !image.naturalWidth) return;
    var isPdf = uploadedFile.type === 'application/pdf' || /\.pdf$/i.test(uploadedFile.name);
    if (isPdf) {
      /* The on-screen PDF image is only a temporary page-1 preview. Its pixel
         dimensions do not describe the original PDF, which may contain vector
         artwork, so never issue a false low-resolution warning from it. */
      currentImageQuality = 'PDF';
      qualityWarningAccepted = true;
      qualityPanel.hidden = false;
      qualityPanel.setAttribute('data-quality-level', 'good');
      one('[data-quality-badge]', qualityPanel).textContent = 'PDF';
      one('[data-quality-title]', qualityPanel).textContent = 'PDF selected';
      one('[data-quality-message]', qualityPanel).textContent = 'The original PDF will be uploaded when you add your sign to the cart.';
      one('[data-quality-details]', qualityPanel).textContent = 'Page 1 is shown only as a cropping preview. Final PDF quality will be reviewed from the original file.';
      var pdfQualityProperty = one('[data-property-quality]', root);
      var pdfResolutionProperty = one('[data-property-effective-resolution]', root);
      var pdfPixelsProperty = one('[data-property-pixel-size]', root);
      if (pdfQualityProperty) pdfQualityProperty.value = 'PDF — quality requires original-file review';
      if (pdfResolutionProperty) pdfResolutionProperty.value = 'Not estimated from PDF preview';
      if (pdfPixelsProperty) pdfPixelsProperty.value = 'PDF page 1 preview only';
      return;
    }
    var cropPixels = sourceCropPixels(size);
    var effectivePpi = Math.floor(Math.min(cropPixels.width / size.width, cropPixels.height / size.height));
    var quality = effectivePpi >= 150 ? 'Excellent' : effectivePpi >= 100 ? 'Good' : effectivePpi >= 72 ? 'Fair' : 'Low';
    currentImageQuality = quality;
    var title = quality === 'Excellent' ? 'Excellent print resolution' :
      quality === 'Good' ? 'Good for a large-format sign' :
      quality === 'Fair' ? 'May look soft when viewed closely' : 'Resolution is too low for this print size';
    var message = quality === 'Low'
      ? 'Please upload a larger original image or choose a smaller finished size.'
      : 'The resolution is suitable for the selected crop and finished measurements.';
    var maxWidthAt100 = Math.max(1, Math.floor(cropPixels.width / 100));
    var maxHeightAt100 = Math.max(1, Math.floor(cropPixels.height / 100));
    qualityPanel.hidden = false;
    qualityPanel.setAttribute('data-quality-level', quality.toLowerCase());
    one('[data-quality-badge]', qualityPanel).textContent = quality;
    one('[data-quality-title]', qualityPanel).textContent = title;
    one('[data-quality-message]', qualityPanel).textContent = message;
    one('[data-quality-details]', qualityPanel).textContent =
      image.naturalWidth + ' × ' + image.naturalHeight + ' pixels · approximately ' + effectivePpi +
      ' effective PPI after cropping · recommended maximum near ' + maxWidthAt100 + ' × ' + maxHeightAt100 + ' inches.';
    var qualityProperty = one('[data-property-quality]', root);
    var resolutionProperty = one('[data-property-effective-resolution]', root);
    var pixelsProperty = one('[data-property-pixel-size]', root);
    if (qualityProperty) qualityProperty.value = quality;
    if (resolutionProperty) resolutionProperty.value = effectivePpi + ' PPI after crop';
    if (pixelsProperty) pixelsProperty.value = image.naturalWidth + ' × ' + image.naturalHeight + ' px';
  }

  function cleanNumber(value) {
    return String(Math.round(value * 1000) / 1000);
  }

  function panelWidthLimit() {
    return Infinity;
  }

  function panelHeightLimit() {
    return Infinity;
  }

  function artworkRatio() {
    if (!image.naturalWidth || !image.naturalHeight) return 0;
    return image.naturalWidth / image.naturalHeight;
  }

  /* Customer measurements are never rewritten while they type. */
  function applyPanelLimits() {
    panelWidthInputs.concat(panelHeightInputs).forEach(function (input) {
      input.removeAttribute('max');
    });
  }

  function enteredPanelMeasurements() {
    var multiplier = activeSizeUnit === 'feet' ? 12 : 1;
    var panels = [];
    for (var index = 0; index < panelCount; index += 1) {
      var widthText = String(panelWidthInputs[index].value || '').trim();
      var heightText = String(panelHeightInputs[index].value || '').trim();
      panels.push({
        width: widthText === '' ? null : number(widthText, 0) * multiplier,
        height: heightText === '' ? null : number(heightText, 0) * multiplier
      });
    }
    return panels;
  }

  function firstIncompletePanel() {
    var panels = enteredPanelMeasurements();
    for (var index = 0; index < panels.length; index += 1) {
      if (!panels[index].width || !panels[index].height) return index;
    }
    return -1;
  }

  function individualPanelWidthLimit(panelIndex) {
    if (panelCount === 1 || panelIndex === 0) return Infinity;
    var ratio = artworkRatio();
    var panels = enteredPanelMeasurements();
    if (!ratio || !panels[panelIndex] || !panels[panelIndex].height) return Infinity;
    var maximumHeight = 0;
    var usedWidth = 0;
    for (var index = 0; index <= panelIndex; index += 1) {
      if (!panels[index].height) return Infinity;
      maximumHeight = Math.max(maximumHeight, panels[index].height);
      if (index < panelIndex) {
        if (!panels[index].width) return Infinity;
        usedWidth += panels[index].width;
      }
    }
    return Math.max(0, maximumHeight * ratio - usedWidth);
  }

  function hidePanelWidthPopups() {
    panelWidthPopups.forEach(function (popup) { popup.hidden = true; });
  }

  function showPanelWidthPopup(panelIndex) {
    if (panelCount === 1 || panelIndex === 0 || panelIndex >= panelCount) return;
    var popup = panelWidthPopups[panelIndex];
    if (!popup) return;
    var limitInches = individualPanelWidthLimit(panelIndex);
    if (!isFinite(limitInches)) return;
    var divisor = activeSizeUnit === 'feet' ? 12 : 1;
    var shownLimit = Math.floor(((limitInches / divisor) + 0.000000001) * 1000) / 1000;
    var enteredPanels = enteredPanelMeasurements();
    var enteredWidth = enteredPanels[panelIndex].width;
    var message = one('[data-panel-width-popup-message]', popup);
    hidePanelWidthPopups();
    if (enteredWidth !== null && enteredWidth > limitInches + .00001) {
      var previousWidth = enteredPanels.slice(0, panelIndex).reduce(function (total, panel) {
        return total + (panel.width || 0);
      }, 0);
      var shownPreviousWidth = cleanNumber(previousWidth / divisor);
      var unit = activeSizeUnit === 'feet' ? ' feet' : ' inches';
      if (message && panelIndex === 1) {
        message.textContent = 'Panel 1 is complete. Panel 2 does not fit because Panel 1 already uses ' +
          shownPreviousWidth + unit + '. Reduce Panel 2 to ' + cleanNumber(shownLimit) + unit +
          ' or less so Panels 1 and 2 fit the full picture.';
      } else if (message) {
        var excessInches = enteredWidth - limitInches;
        var shownExcess = cleanNumber(Math.floor(((excessInches / divisor) + .000000001) * 1000) / 1000);
        var shownCurrentWidth = cleanNumber(enteredWidth / divisor);
        var completedPanelNames = panelIndex === 2 ? 'Panels 1 and 2' : 'Panels 1, 2, and 3';
        var completedSizeParts = enteredPanels.slice(0, panelIndex).map(function (panel, index) {
          return 'Panel ' + (index + 1) + ' is ' + cleanNumber(panel.width / divisor) + unit;
        });
        var completedSizes = completedSizeParts.length > 1
          ? completedSizeParts.slice(0, -1).join(', ') + ' and ' + completedSizeParts[completedSizeParts.length - 1]
          : completedSizeParts[0];
        var alternatives = enteredPanels.slice(0, panelIndex).map(function (panel, index) {
          var newWidthInches = panel.width - excessInches;
          if (newWidthInches < 1 - .00001) return '';
          var safeNewWidth = Math.floor(((newWidthInches / divisor) + .000000001) * 1000) / 1000;
          return 'reduce Panel ' + (index + 1) + ' to ' + cleanNumber(safeNewWidth) + unit;
        }).filter(Boolean);
        var choices = alternatives.length > 1
          ? alternatives.slice(0, -1).join(', ') + ', or ' + alternatives[alternatives.length - 1]
          : alternatives[0];
        var canSplitEarlierPanels = enteredPanels.slice(0, panelIndex).reduce(function (total, panel) {
          return total + Math.max(0, panel.width - 1);
        }, 0) >= excessInches - .00001;
        message.textContent = completedPanelNames + ' are complete: ' + completedSizes +
          ' (' + shownPreviousWidth + unit + ' total). Panel ' + (panelIndex + 1) + ' at ' +
          shownCurrentWidth + unit + ' makes the full layout ' + shownExcess + unit + ' too wide. ' +
          (choices
            ? 'To keep Panel ' + (panelIndex + 1) + ' at ' + shownCurrentWidth + unit + ', ' + choices + '.'
            : 'The earlier panels cannot be reduced enough by themselves. Reduce Panel ' +
              (panelIndex + 1) + ' to ' + cleanNumber(shownLimit) + unit + ' or less.') +
          (canSplitEarlierPanels && alternatives.length > 1
            ? ' You may also split the ' + shownExcess + unit + ' reduction between the completed panels.'
            : '');
      }
      popup.hidden = false;
    }
  }

  /* Wait briefly after the last number is typed, then explain any size issue.
     The customer does not have to press Enter or leave the field. */
  function schedulePanelWidthPopup(panelIndex) {
    if (panelPopupTimers[panelIndex]) window.clearTimeout(panelPopupTimers[panelIndex]);
    if (panelIndex === 0 || panelIndex >= panelCount) return;
    if (panelWidthPopups[panelIndex]) panelWidthPopups[panelIndex].hidden = true;
    panelPopupTimers[panelIndex] = window.setTimeout(function () {
      panelPopupTimers[panelIndex] = 0;
      showPanelWidthPopup(panelIndex);
    }, 700);
  }

  function updatePanelStatuses() {
    var panels = enteredPanelMeasurements();
    panelStatuses.forEach(function (status, index) {
      status.classList.remove('is-error', 'is-waiting');
      if (index >= panelCount || !panels[index] || !panels[index].width || !panels[index].height) {
        status.hidden = true;
        return;
      }
      var earlierIncomplete = panels.slice(0, index).some(function (panel) {
        return !panel.width || !panel.height;
      });
      if (earlierIncomplete) {
        status.textContent = 'Enter earlier panel';
        status.classList.add('is-waiting');
        status.hidden = false;
        return;
      }
      var limit = individualPanelWidthLimit(index);
      var fits = index === 0 || !isFinite(limit) || panels[index].width <= limit + .00001;
      status.textContent = fits ? '✓ Complete' : '! Does not fit';
      status.classList.toggle('is-error', !fits);
      status.hidden = false;
      if (fits && panelWidthPopups[index]) panelWidthPopups[index].hidden = true;
    });
  }

  function firstPanelWidthViolation() {
    if (panelCount === 1) return -1;
    var panels = enteredPanelMeasurements();
    for (var index = 1; index < panelCount; index += 1) {
      if (panels[index].width > individualPanelWidthLimit(index) + .00001) return index;
    }
    return -1;
  }

  function saveCurrentPanelState() {
    var multiplier = activeSizeUnit === 'feet' ? 12 : 1;
    if (panelCount === 1) {
      singlePanelSize.width = number(panelWidthInputs[0].value, singlePanelSize.width / multiplier) * multiplier;
      singlePanelSize.height = number(panelHeightInputs[0].value, singlePanelSize.height / multiplier) * multiplier;
      return;
    }
    for (var index = 0; index < panelCount; index += 1) {
      var widthText = String(panelWidthInputs[index].value || '').trim();
      var heightText = String(panelHeightInputs[index].value || '').trim();
      splitPanelSizes[index].width = widthText === '' ? '' : number(widthText, 0) * multiplier;
      splitPanelSizes[index].height = heightText === '' ? '' : number(heightText, 0) * multiplier;
    }
  }

  function loadPanelState() {
    var divisor = activeSizeUnit === 'feet' ? 12 : 1;
    panelWidthInputs.forEach(function (input, index) {
      var stored = panelCount === 1 && index === 0 ? singlePanelSize.width : splitPanelSizes[index].width;
      input.value = stored === '' ? '' : cleanNumber(stored / divisor);
    });
    panelHeightInputs.forEach(function (input, index) {
      var stored = panelCount === 1 && index === 0 ? singlePanelSize.height : splitPanelSizes[index].height;
      input.value = stored === '' ? '' : cleanNumber(stored / divisor);
    });
  }

  function restoreEditMeasurements() {
    if (!editingOriginalProperties) return;
    var properties = editingOriginalProperties;
    var restoredPanels = [];
    String(properties['_Panel run'] || '').split('|').forEach(function (entry) {
      var parts = entry.split('x');
      var restoredWidth = number(parts[0], 0);
      var restoredHeight = number(parts[1], 0);
      if (restoredWidth > 0 && restoredHeight > 0) restoredPanels.push({ width: restoredWidth, height: restoredHeight });
    });
    if (restoredPanels.length > 1) {
      panelCount = clamp(restoredPanels.length, 2, 4);
      restoredPanels.forEach(function (panel, index) {
        splitPanelSizes[index] = { width: panel.width, height: panel.height };
      });
    } else {
      panelCount = 1;
      singlePanelSize.width = number(properties['Width'], singlePanelSize.width);
      singlePanelSize.height = number(properties['Height'], singlePanelSize.height);
    }
    activeSizeUnit = 'inches';
    loadPanelState();
    panelCountButtons.forEach(function (control) {
      var selected = number(control.getAttribute('data-panel-count'), 1) === panelCount;
      control.classList.toggle('is-active', selected);
      control.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });
    panelRows.forEach(function (row, index) { row.hidden = index >= panelCount; });
    cropX = clamp(number(properties['_Crop X'], .5), 0, 1);
    cropY = clamp(number(properties['_Crop Y'], .5), 0, 1);
    activeMovement = properties['_Crop mode'] === 'vertical' ? 'vertical' : 'horizontal';
    if (properties['Grommets']) {
      Array.prototype.some.call(grommets.options, function (option, index) {
        if (option.value !== properties['Grommets']) return false;
        grommets.selectedIndex = index;
        return true;
      });
    }
    var qualityProperty = one('[data-property-quality]', root);
    var resolutionProperty = one('[data-property-effective-resolution]', root);
    var pixelsProperty = one('[data-property-pixel-size]', root);
    if (qualityProperty) qualityProperty.value = properties['Image quality'] || '';
    if (resolutionProperty) resolutionProperty.value = properties['Effective resolution'] || '';
    if (pixelsProperty) pixelsProperty.value = properties['Uploaded pixel size'] || '';
    if (button) button.textContent = 'Update customized sign';
  }

  restoreEditMeasurements();

  function activePanelMeasurements() {
    var multiplier = activeSizeUnit === 'feet' ? 12 : 1;
    var widthCeiling = panelWidthLimit();
    var fallbackHeight = 48;
    for (var fallbackIndex = 0; fallbackIndex < panelCount; fallbackIndex += 1) {
      var enteredHeight = number(panelHeightInputs[fallbackIndex].value, 0) * multiplier;
      if (enteredHeight > 0) { fallbackHeight = enteredHeight; break; }
    }
    var fallbackWidth = fallbackHeight * (artworkRatio() || 2) / Math.max(1, panelCount);
    var panels = [];
    for (var index = 0; index < panelCount; index += 1) {
      var widthText = String(panelWidthInputs[index].value || '').trim();
      var heightText = String(panelHeightInputs[index].value || '').trim();
      panels.push({
        width: clamp(widthText === '' ? fallbackWidth : number(widthText, fallbackWidth) * multiplier, 1, widthCeiling),
        height: clamp(heightText === '' ? fallbackHeight : number(heightText, fallbackHeight) * multiplier, 1, panelHeightLimit())
      });
    }
    return panels;
  }

  function dimensions() {
    var panels = activePanelMeasurements();
    var totalWidth = panels.reduce(function (sum, panel) { return sum + panel.width; }, 0);
    var maximumHeight = panels.reduce(function (maximum, panel) { return Math.max(maximum, panel.height); }, 1);
    return {
      width: totalWidth,
      height: maximumHeight,
      panels: panels,
      panelCount: panels.length
    };
  }

  function updateUnitDisplay(size) {
    sizeUnitLabels.forEach(function (label) {
      label.textContent = activeSizeUnit === 'feet' ? 'ft' : 'inch';
    });
    if (sizeConversion) {
      sizeConversion.textContent = size.panelCount === 1
        ? cleanNumber(size.width) + ' inches × ' + cleanNumber(size.height) +
          ' inches = ' + cleanNumber(size.width / 12) + ' feet × ' + cleanNumber(size.height / 12) + ' feet'
        : size.panels.map(function (panel, index) {
            return 'Panel ' + (index + 1) + ': ' + cleanNumber(panel.width) + ' × ' + cleanNumber(panel.height) + ' inches';
          }).join(' · ') + ' · Total span: ' + cleanNumber(size.width) + ' inches';
    }
  }

  function setSizeUnit(unit) {
    if (unit === activeSizeUnit) return;
    hidePanelWidthPopups();
    saveCurrentPanelState();
    activeSizeUnit = unit;
    var isFeet = unit === 'feet';
    panelWidthInputs.concat(panelHeightInputs).forEach(function (input) {
      input.min = isFeet ? '0.083' : '1';
      input.step = isFeet ? '0.01' : '0.1';
    });
    loadPanelState();
    sizeUnitButtons.forEach(function (control) {
      var selected = control.getAttribute('data-size-unit') === unit;
      control.classList.toggle('is-active', selected);
      control.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });
    applyPanelLimits();
    update();
  }

  function grommetMode() {
    var option = grommets.options[grommets.selectedIndex];
    return option ? option.getAttribute('data-mode') : 'none';
  }

  /* Every panel is its own printed sign, so it carries its own grommets. One
     sign is just the single-panel case of the same sum. */
  function grommetDetails() {
    return dimensions().panels.reduce(function (total, panel) {
      var detail = grommetDetailsForPanel(panel);
      total.count += detail.count;
      total.price += detail.price;
      return total;
    }, { count: 0, price: 0 });
  }

  function grommetDetailsForPanel(panel) {
    var mode = grommetMode();
    var grommetSpacingInches = 24;
    var topCount = Math.max(1, Math.ceil(panel.width / grommetSpacingInches));
    var allSidesTopCount = Math.max(2, Math.ceil(panel.width / grommetSpacingInches));
    var allSidesInteriorSideCount = Math.max(0, Math.ceil(panel.height / grommetSpacingInches) - 2);
    var count = 0;
    var price = 0;

    if (mode === 'corners') {
      count = 4;
      price = cornerGrommetPrice;
    } else if (mode === 'top') {
      count = topCount;
      price = count * grommetUnitPrice;
    } else if (mode === 'top-bottom') {
      count = topCount * 2;
      price = count * grommetUnitPrice;
    } else if (mode === 'all-sides') {
      count = allSidesTopCount * 2 + allSidesInteriorSideCount * 2;
      price = count * grommetUnitPrice;
    }

    return { count: count, price: price };
  }

  function updateGrommetLabels() {
    Array.prototype.forEach.call(grommets.options, function (option) {
      var selectedIndex = grommets.selectedIndex;
      grommets.selectedIndex = option.index;
      var details = grommetDetails();
      var label = option.getAttribute('data-label') || option.value;
      option.textContent = details.price
        ? label + ' (' + details.count + ' grommets, +' + money(details.price, symbol) + ')'
        : label;
      grommets.selectedIndex = selectedIndex;
    });
  }

  function calculatedPrice() {
    var size = dimensions();
    var squareFeet = size.panels.reduce(function (total, panel) {
      return total + panel.width * panel.height / 144;
    }, 0);
    var billedSquareFeet = Math.floor(squareFeet);
    var grommet = grommetDetails();
    return {
      squareFeet: squareFeet,
      billedSquareFeet: billedSquareFeet,
      printPrice: basePrice + billedSquareFeet * squareFootPrice,
      total: basePrice + billedSquareFeet * squareFootPrice + grommet.price,
      grommetCount: grommet.count,
      grommetPrice: grommet.price
    };
  }

  function renderImage() {
    if (!image.naturalWidth || !image.naturalHeight) return;
    var boxWidth = viewport.clientWidth;
    var boxHeight = viewport.clientHeight;
    var scale = movementScale(image.naturalWidth, image.naturalHeight, boxWidth, boxHeight, activeMovement);
    var renderedWidth = image.naturalWidth * scale;
    var renderedHeight = image.naturalHeight * scale;
    var position = movementPosition(activeMovement, cropX, cropY);
    /* Width and height change only when the sign does, so writing them every
       pointer move costs a layout for nothing. The picture is moved with a
       transform instead of left/top: the browser can slide a composited layer
       without laying the page out again, which is what kept the drag smooth on
       phones and on very large artwork. */
    var nextWidth = pixelSnap(renderedWidth) + 'px';
    var nextHeight = pixelSnap(renderedHeight) + 'px';
    if (image.style.width !== nextWidth) image.style.width = nextWidth;
    if (image.style.height !== nextHeight) image.style.height = nextHeight;
    if (image.style.left !== '0px') { image.style.left = '0px'; image.style.top = '0px'; }
    image.style.transform = 'translate3d(' +
      pixelSnap(movementOffset(renderedWidth, boxWidth, position.x)) + 'px,' +
      pixelSnap(movementOffset(renderedHeight, boxHeight, position.y)) + 'px,0)';
    renderPanelGuides();
    renderContextPreview();
  }

  var lastGuideKey = '';

  function renderPanelGuides() {
    if (!panelGuides) return;
    var size = dimensions();
    /* The seam markers depend on the panel sizes, not on where the picture
       has been dragged to. Rebuilding them on every pointer move threw away
       and recreated DOM for no visible change. */
    var guideKey = size.panels.map(function (panel) {
      return panel.width + 'x' + panel.height;
    }).join('|');
    if (guideKey === lastGuideKey) return;
    lastGuideKey = guideKey;
    panelGuides.replaceChildren();
    var left = 0;
    size.panels.forEach(function (panel, index) {
      var guide = document.createElement('span');
      var widthPercent = panel.width / size.width * 100;
      var heightPercent = panel.height / size.height * 100;
      guide.className = 'sign-customizer__panel-guide';
      guide.setAttribute('data-panel-label', size.panelCount > 1 ? 'Panel ' + (index + 1) : 'Full sign');
      guide.style.left = left + '%';
      guide.style.width = widthPercent + '%';
      guide.style.height = heightPercent + '%';
      if (heightPercent < 100) {
        var mask = document.createElement('i');
        mask.className = 'sign-customizer__panel-mask';
        mask.style.top = '100%';
        mask.style.height = ((100 - heightPercent) / heightPercent * 100) + '%';
        guide.appendChild(mask);
      }
      panelGuides.appendChild(guide);
      left += widthPercent;
    });
  }


  function renderContextPreview() {
    if (!contextPreview || !contextImage || !contextSelection || !image.naturalWidth) return;
    var size = dimensions();
    var frameRatio = size.width / size.height;
    var imageRatio = image.naturalWidth / image.naturalHeight;
    var difference = Math.max(frameRatio / imageRatio, imageRatio / frameRatio);
    /* Only touch the attribute when it actually changes: flipping `hidden`
       resizes the page, which some browsers answer with another resize
       event — that round trip is what used to lock the page up. */
    var shouldHide = difference < 3;
    if (contextPreview.hidden !== shouldHide) contextPreview.hidden = shouldHide;
    if (shouldHide) return;

    var boxWidth = contextPreview.clientWidth;
    var boxHeight = contextPreview.clientHeight;
    var fittedWidth;
    var fittedHeight;
    var fittedLeft;
    var fittedTop;
    if (boxWidth / boxHeight > imageRatio) {
      fittedHeight = boxHeight;
      fittedWidth = fittedHeight * imageRatio;
      fittedLeft = (boxWidth - fittedWidth) / 2;
      fittedTop = 0;
    } else {
      fittedWidth = boxWidth;
      fittedHeight = fittedWidth / imageRatio;
      fittedLeft = 0;
      fittedTop = (boxHeight - fittedHeight) / 2;
    }

    if (frameRatio > imageRatio) {
      var bandHeight = Math.max(8, fittedWidth / frameRatio);
      contextSelection.style.left = fittedLeft + 'px';
      contextSelection.style.width = fittedWidth + 'px';
      contextSelection.style.height = bandHeight + 'px';
      contextSelection.style.top = (fittedTop + (fittedHeight - bandHeight) * cropY) + 'px';
    } else {
      var bandWidth = Math.max(8, fittedHeight * frameRatio);
      contextSelection.style.top = fittedTop + 'px';
      contextSelection.style.height = fittedHeight + 'px';
      contextSelection.style.width = bandWidth + 'px';
      contextSelection.style.left = (fittedLeft + (fittedWidth - bandWidth) * cropX) + 'px';
    }
  }

  /* The stage column is the stable thing to measure. The row that wraps the
     picture shrinks to fit the picture on phones, so measuring the row would
     feed the picture's own width back into its next size calculation. */
  function stageWidth() {
    var column = one('.sign-customizer__stage-column', root);
    var measured = (column && column.clientWidth) || (viewport.parentElement && viewport.parentElement.clientWidth) || 0;
    if (!measured) measured = Math.max(180, window.innerWidth - 32);
    var gutter = window.innerWidth <= 767 ? 0 : 45;
    return Math.max(180, measured - gutter);
  }

  function sizeViewport(size) {
    var availableWidth = stageWidth();
    var availableHeight = window.innerWidth <= 767
      ? Math.min(420, Math.max(220, stableWindowHeight * .45))
      : Math.min(460, Math.max(240, stableWindowHeight * .48));
    var ratio = size.width / size.height;
    var displayWidth;
    var displayHeight;
    if (availableWidth / availableHeight > ratio) {
      displayHeight = availableHeight;
      displayWidth = displayHeight * ratio;
    } else {
      displayWidth = availableWidth;
      displayHeight = displayWidth / ratio;
    }
    displayWidth = Math.max(8, Math.min(displayWidth, availableWidth));
    displayHeight = Math.max(8, displayHeight);

    /* Skip sub-pixel rewrites. Re-setting an identical size still forces a
       reflow, and on browsers where that toggles a scrollbar it can bounce
       between two sizes forever. */
    if (Math.abs(displayWidth - lastViewportWidth) < .5 && Math.abs(displayHeight - lastViewportHeight) < .5) return;
    lastViewportWidth = displayWidth;
    lastViewportHeight = displayHeight;
    viewport.style.width = displayWidth + 'px';
    viewport.style.height = displayHeight + 'px';
    viewport.style.aspectRatio = size.width + ' / ' + size.height;
  }

  function update() {
    /* A single guarded entry point: anything that fires while an update is
       already running is ignored instead of nesting. */
    if (updating) return;
    updating = true;
    try {
      performUpdate();
    } finally {
      updating = false;
    }
  }

  function performUpdate() {
    var size = dimensions();
    updatePanelStatuses();
    updateUnitDisplay(size);
    updateGrommetLabels();
    var price = calculatedPrice();
    sizeViewport(size);
    one('[data-width-label]', root).textContent = activeSizeUnit === 'feet' ? cleanNumber(size.width / 12) + ' ft' : cleanNumber(size.width) + '"';
    one('[data-height-label]', root).textContent = activeSizeUnit === 'feet' ? cleanNumber(size.height / 12) + ' ft' : cleanNumber(size.height) + '"';
    one('[data-custom-price]', root).textContent = money(price.total, symbol);
    one('[data-price-breakdown]', root).textContent =
      price.squareFeet.toFixed(2) + ' actual sq. ft. → ' + price.billedSquareFeet +
      ' billed sq. ft. × ' + money(squareFootPrice, symbol) +
      ' + ' + money(basePrice, symbol) + ' design fee' +
      (price.grommetPrice
        ? (grommetMode() === 'corners'
          ? ' + ' + money(price.grommetPrice, symbol) + ' four-corner grommets'
          : ' + ' + price.grommetCount + ' grommets × ' + money(grommetUnitPrice, symbol) + ' = ' + money(price.grommetPrice, symbol))
        : '');
    one('[data-property-width]', root).value = cleanNumber(size.width) + ' inch';
    one('[data-property-height]', root).value = cleanNumber(size.height) + ' inch';
    /* A single sign says everything it needs to in Width and Height, so the
       panel lines are left off the order entirely. They appear only when the
       shopper actually split the picture. */
    var split = size.panelCount > 1;
    var panelLayoutProperty = one('[data-property-panel-layout]', root);
    if (panelLayoutProperty) {
      panelLayoutProperty.disabled = !split;
      panelLayoutProperty.value = split
        ? 'Continuous picture split into ' + size.panelCount + ' separate panels'
        : '';
    }
    all('[data-property-panel-measurements]', root).forEach(function (property, index) {
      var active = split && index < size.panelCount;
      property.disabled = !active;
      property.value = active
        ? cleanNumber(size.panels[index].width) + ' × ' + cleanNumber(size.panels[index].height) + ' inches'
        : '';
    });
    var panelRunProperty = one('[data-property-panel-run]', root);
    if (panelRunProperty) panelRunProperty.value = size.panels.map(function (panel) {
      return cleanNumber(panel.width) + 'x' + cleanNumber(panel.height);
    }).join('|');
    one('[data-property-grommets]', root).value = grommets.value;
    one('[data-property-grommet-count]', root).value = price.grommetCount;
    one('[data-property-price]', root).value = money(price.total, symbol);
    one('[data-property-billed-square-feet]', root).value = price.billedSquareFeet;
    one('[data-property-view-position]', root).value =
      'Horizontal ' + Math.round(cropX * 100) + '%, Vertical ' + Math.round(cropY * 100) + '%';
    one('[data-property-crop-x]', root).value = cropX.toFixed(6);
    one('[data-property-crop-y]', root).value = cropY.toFixed(6);
    one('[data-property-crop-mode]', root).value = activeMovement;
    one('[data-property-source]', root).value = root.getAttribute('data-image-url');
    if (uploadEnabled && uploadedFile) one('[data-property-source]', root).value = '';
    renderImage();
    updateImageQuality(size);
    /* A property with nothing in it still shows as a blank line in the cart and
       at the checkout. Leave those out of the order, so what the shopper reads
       there is their panels and nothing else. */
    ['[data-property-quality]', '[data-property-effective-resolution]', '[data-property-pixel-size]']
      .forEach(function (selector) {
        var property = one(selector, root);
        if (property) property.disabled = !property.value;
      });
    announceChange(size);
    updateMovementControls();
  }

  /* Hand the panel layout to the 3D sukkah preview. It listens rather than
     reaching in here, so this file stays the single owner of the maths.

     A drag fires this dozens of times a second, and each one asks the 3D view
     to rebuild. Coalesce them: at most one announcement per animation frame,
     always carrying the newest numbers. */
  var announceFrame = 0;

  function announceChange(size) {
    if (typeof window.CustomEvent !== 'function') return;
    if (!window.requestAnimationFrame) return announceNow(size);
    if (announceFrame) return;
    announceFrame = window.requestAnimationFrame(function () {
      announceFrame = 0;
      announceNow(dimensions());
    });
  }

  function announceNow(size) {
    var left = 0;
    var panels = size.panels.map(function (panel) {
      var entry = { width: panel.width, height: panel.height, left: left };
      left += panel.width;
      return entry;
    });
    document.dispatchEvent(new CustomEvent('sign:change', {
      detail: {
        walls: panels,
        muralWidth: size.width,
        muralHeight: size.height,
        cropX: cropX,
        cropY: cropY,
        mode: activeMovement,
        grommetMode: grommetMode(),
        imageUrl: (uploadEnabled && uploadedObjectUrl) ? uploadedObjectUrl : (root.getAttribute('data-image-url') || '')
      }
    }));
  }

  function updateMovementControls() {
    if (!image.naturalWidth || !image.naturalHeight) return;
    var baseScale = coverScale(image.naturalWidth, image.naturalHeight, viewport.clientWidth, viewport.clientHeight);
    var overflowX = Math.max(0, image.naturalWidth * baseScale - viewport.clientWidth);
    var overflowY = Math.max(0, image.naturalHeight * baseScale - viewport.clientHeight);
    var horizontal = one('[data-movement-horizontal]', root);
    var vertical = one('[data-movement-vertical]', root);
    var hint = one('[data-drag-hint]', root);
    var horizontalActive = overflowX > 1;
    var verticalActive = overflowY > 1;

    if (!horizontalActive && verticalActive && activeMovement !== 'vertical') {
      activeMovement = 'vertical';
      cropX = .5;
    } else if (!verticalActive && horizontalActive && activeMovement !== 'horizontal') {
      activeMovement = 'horizontal';
      cropY = .5;
    }

    horizontal.classList.toggle('is-active', activeMovement === 'horizontal');
    vertical.classList.toggle('is-active', activeMovement === 'vertical');
    horizontal.classList.toggle('is-disabled', !horizontalActive);
    vertical.classList.toggle('is-disabled', !verticalActive);
    horizontal.querySelectorAll('button').forEach(function (control) { control.disabled = !horizontalActive; });
    vertical.querySelectorAll('button').forEach(function (control) { control.disabled = !verticalActive; });

    if (horizontalActive) hint.textContent = 'Drag left or right — the full top and bottom stay visible';
    else if (verticalActive) hint.textContent = 'Drag up or down — the full left and right sides stay visible';
    else hint.textContent = 'Your picture is already centered for this size';

    one('[data-property-crop-x]', root).value = cropX.toFixed(6);
    one('[data-property-crop-y]', root).value = cropY.toFixed(6);
    one('[data-property-crop-mode]', root).value = activeMovement;
  }

  panelWidthInputs.forEach(function (field, panelIndex) {
    field.addEventListener('input', function () {
      qualityWarningAccepted = false;
      saveCurrentPanelState();
      update();
      schedulePanelWidthPopup(panelIndex);
    });
    field.addEventListener('change', function () { qualityWarningAccepted = false; saveCurrentPanelState(); update(); });
  });
  panelHeightInputs.forEach(function (field, panelIndex) {
    field.addEventListener('input', function () {
      qualityWarningAccepted = false;
      saveCurrentPanelState();
      update();
      schedulePanelWidthPopup(panelIndex);
    });
    field.addEventListener('change', function () { qualityWarningAccepted = false; saveCurrentPanelState(); update(); });
    field.addEventListener('blur', function () { showPanelWidthPopup(panelIndex); });
    field.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter') return;
      event.preventDefault();
      field.blur();
    });
  });
  panelWidthPopups.forEach(function (popup) {
    var close = one('[data-close-width-popup]', popup);
    if (close) close.addEventListener('click', function () { popup.hidden = true; });
  });
  [grommets].forEach(function (field) {
    field.addEventListener('input', function () { qualityWarningAccepted = false; update(); });
    field.addEventListener('change', function () { qualityWarningAccepted = false; update(); });
  });

  panelCountButtons.forEach(function (control) {
    control.addEventListener('click', function () {
      saveCurrentPanelState();
      panelCount = clamp(number(control.getAttribute('data-panel-count'), 1), 1, 4);
      loadPanelState();
      panelCountButtons.forEach(function (buttonControl) {
        var selected = number(buttonControl.getAttribute('data-panel-count'), 1) === panelCount;
        buttonControl.classList.toggle('is-active', selected);
        buttonControl.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
      panelRows.forEach(function (row, index) { row.hidden = index >= panelCount; });
      hidePanelWidthPopups();
      applyPanelLimits();
      qualityWarningAccepted = false;
      lastViewportWidth = 0;
      lastViewportHeight = 0;
      update();
    });
  });

  sizeUnitButtons.forEach(function (control) {
    control.addEventListener('click', function () {
      setSizeUnit(control.getAttribute('data-size-unit'));
    });
  });

  if (uploadInput) {
    function waitForPdfLibrary() {
      return new Promise(function (resolve, reject) {
        if (window.CreativeSukkahPdf) {
          resolve(window.CreativeSukkahPdf);
          return;
        }
        var timeout = window.setTimeout(function () {
          window.removeEventListener('creative-sukkah-pdf-ready', ready);
          reject(new Error('The PDF preview tool did not load. Please refresh the page and try again.'));
        }, 12000);
        function ready() {
          window.clearTimeout(timeout);
          resolve(window.CreativeSukkahPdf);
        }
        window.addEventListener('creative-sukkah-pdf-ready', ready, { once: true });
      });
    }

    function renderPdfFirstPage(fileOrUrl) {
      return waitForPdfLibrary().then(function (pdfjsLib) {
        var documentPromise = typeof fileOrUrl === 'string'
          ? pdfjsLib.getDocument({ url: fileOrUrl }).promise
          : fileOrUrl.arrayBuffer().then(function (bytes) {
              return pdfjsLib.getDocument({ data: new Uint8Array(bytes) }).promise;
            });
        return documentPromise.then(function (pdfDocument) {
          return pdfDocument.getPage(1).then(function (page) {
            var baseViewport = page.getViewport({ scale: 1 });
            var longestSide = Math.max(baseViewport.width, baseViewport.height);
            var scale = Math.min(5, 3600 / Math.max(1, longestSide));
            var pdfViewport = page.getViewport({ scale: scale });
            var canvas = document.createElement('canvas');
            canvas.width = Math.max(1, Math.round(pdfViewport.width));
            canvas.height = Math.max(1, Math.round(pdfViewport.height));
            var context = canvas.getContext('2d', { alpha: false });
            context.fillStyle = '#ffffff';
            context.fillRect(0, 0, canvas.width, canvas.height);
            return page.render({ canvasContext: context, viewport: pdfViewport }).promise.then(function () {
              return new Promise(function (resolve, reject) {
                canvas.toBlob(function (blob) {
                  if (!blob) {
                    reject(new Error('The PDF preview could not be created.'));
                    return;
                  }
                  resolve(URL.createObjectURL(blob));
                }, 'image/jpeg', .96);
              });
            });
          });
        });
      });
    }

    function displayUploadedArtwork(previewUrl, preserveCrop) {
      if (uploadedObjectUrl) URL.revokeObjectURL(uploadedObjectUrl);
      uploadedObjectUrl = previewUrl;
      if (!preserveCrop) {
        cropX = .5;
        cropY = .5;
      }
      image.onload = function () {
        if (contextImage) contextImage.src = uploadedObjectUrl;
        applyPanelLimits();
        update();
      };
      image.src = uploadedObjectUrl;
    }

    if (editingOriginalProperties && editingOriginalProperties['Customer artwork']) {
      existingCustomerArtworkUrl = editingOriginalProperties['Customer artwork'];
      var existingFileName = editingOriginalProperties['_Original filename'] || 'Original customer artwork';
      if (uploadFileLabel) uploadFileLabel.textContent = existingFileName + ' — saved artwork loaded';
      if (/\.pdf(?:$|\?)/i.test(existingCustomerArtworkUrl)) {
        pdfPreviewLoading = true;
        renderPdfFirstPage(existingCustomerArtworkUrl).then(function (previewUrl) {
          pdfPreviewLoading = false;
          displayUploadedArtwork(previewUrl, true);
        }).catch(function () {
          pdfPreviewLoading = false;
          var savedPreview = editingOriginalProperties['_CLEAR PRODUCTION CROP'] ||
            editingOriginalProperties['CUSTOMER WATERMARKED PROOF — DO NOT PRINT'];
          if (savedPreview) displayUploadedArtwork(savedPreview, true);
        });
      } else {
        displayUploadedArtwork(existingCustomerArtworkUrl, true);
      }
    }

    uploadInput.addEventListener('change', function () {
      var file = uploadInput.files && uploadInput.files[0];
      error.hidden = true;
      if (!file) {
        uploadedFile = null;
        if (uploadFileLabel) uploadFileLabel.textContent = 'No picture selected';
        if (qualityPanel) qualityPanel.hidden = true;
        return;
      }
      var isPdf = file.type === 'application/pdf' || /\.pdf$/i.test(file.name);
      if (!isPdf && !/^image\/(jpeg|png|webp)$/.test(file.type)) {
        uploadInput.value = '';
        error.textContent = 'Please upload a JPG, PNG, WEBP, or PDF file.';
        error.hidden = false;
        return;
      }
      if (file.size > 20 * 1024 * 1024) {
        uploadInput.value = '';
        error.textContent = 'This file is larger than 20 MB. Please save a high-quality JPG or PDF under 20 MB and try again.';
        error.hidden = false;
        return;
      }
      uploadedFile = file;
      existingCustomerArtworkUrl = '';
      qualityWarningAccepted = false;
      if (uploadFileLabel) uploadFileLabel.textContent = file.name;
      if (isPdf) {
        pdfPreviewLoading = true;
        if (uploadFileLabel) uploadFileLabel.textContent = file.name + ' — preparing page 1 preview…';
        renderPdfFirstPage(file).then(function (previewUrl) {
          pdfPreviewLoading = false;
          if (uploadFileLabel) uploadFileLabel.textContent = file.name + ' — page 1 ready';
          displayUploadedArtwork(previewUrl);
        }).catch(function (problem) {
          pdfPreviewLoading = false;
          uploadedFile = null;
          uploadInput.value = '';
          error.textContent = (problem && problem.message) || 'The PDF could not be opened. Please use a valid one-page PDF.';
          error.hidden = false;
          if (uploadFileLabel) uploadFileLabel.textContent = 'No picture selected';
        });
      } else {
        displayUploadedArtwork(URL.createObjectURL(file));
      }
    });
  }

  viewport.addEventListener('pointerdown', function (event) {
    dragging = true;
    lastX = event.clientX;
    lastY = event.clientY;
    viewport.classList.add('is-dragging');
    viewport.setPointerCapture(event.pointerId);
  });
  viewport.addEventListener('pointermove', function (event) {
    if (!dragging) return;
    var overflowX = Math.max(0, image.offsetWidth - viewport.clientWidth);
    var overflowY = Math.max(0, image.offsetHeight - viewport.clientHeight);
    if (activeMovement === 'horizontal' && overflowX) cropX = clamp(cropX - (event.clientX - lastX) / overflowX, 0, 1);
    if (activeMovement === 'vertical' && overflowY) cropY = clamp(cropY - (event.clientY - lastY) / overflowY, 0, 1);
    lastX = event.clientX;
    lastY = event.clientY;
    update();
  });
  function stopDragging() {
    dragging = false;
    viewport.classList.remove('is-dragging');
  }
  viewport.addEventListener('pointerup', stopDragging);
  viewport.addEventListener('pointercancel', stopDragging);

  if (contextPreview) {
    contextPreview.addEventListener('pointerdown', function (event) {
      if (contextPreview.hidden) return;
      event.preventDefault();
      contextDragging = true;
      lastX = event.clientX;
      lastY = event.clientY;
      contextPreview.classList.add('is-dragging');
      contextPreview.setPointerCapture(event.pointerId);
    });
    contextPreview.addEventListener('pointermove', function (event) {
      if (!contextDragging) return;
      event.preventDefault();
      var deltaX = event.clientX - lastX;
      var deltaY = event.clientY - lastY;
      if (activeMovement === 'horizontal') {
        var horizontalTravel = Math.max(1, contextPreview.clientWidth - contextSelection.offsetWidth);
        cropX = clamp(cropX + deltaX / horizontalTravel, 0, 1);
      } else {
        var verticalTravel = Math.max(1, contextPreview.clientHeight - contextSelection.offsetHeight);
        cropY = clamp(cropY + deltaY / verticalTravel, 0, 1);
      }
      lastX = event.clientX;
      lastY = event.clientY;
      update();
    });
    function stopContextDragging() {
      contextDragging = false;
      contextPreview.classList.remove('is-dragging');
    }
    contextPreview.addEventListener('pointerup', stopContextDragging);
    contextPreview.addEventListener('pointercancel', stopContextDragging);
  }

  root.querySelectorAll('[data-nudge]').forEach(function (nudge) {
    nudge.addEventListener('click', function () {
      var direction = nudge.getAttribute('data-nudge');
      var nextMovement = direction === 'left' || direction === 'right' ? 'horizontal' : 'vertical';
      if (nextMovement !== activeMovement) {
        activeMovement = nextMovement;
        cropX = .5;
        cropY = .5;
      }
      if (direction === 'left') cropX = clamp(cropX - .04, 0, 1);
      if (direction === 'right') cropX = clamp(cropX + .04, 0, 1);
      if (direction === 'up') cropY = clamp(cropY - .04, 0, 1);
      if (direction === 'down') cropY = clamp(cropY + .04, 0, 1);
      update();
    });
  });
  root.querySelectorAll('[data-select-movement]').forEach(function (selector) {
    selector.addEventListener('click', function () {
      activeMovement = selector.getAttribute('data-select-movement');
      cropX = .5;
      cropY = .5;
      update();
    });
  });
  one('[data-center-image]', root).addEventListener('click', function () {
    cropX = .5;
    cropY = .5;
    update();
    window.requestAnimationFrame(function () {
      cropX = .5;
      cropY = .5;
      var boxWidth = viewport.clientWidth;
      var boxHeight = viewport.clientHeight;
      var scale = movementScale(image.naturalWidth, image.naturalHeight, boxWidth, boxHeight, activeMovement);
      var renderedWidth = image.naturalWidth * scale;
      var renderedHeight = image.naturalHeight * scale;
      image.style.width = renderedWidth + 'px';
      image.style.height = renderedHeight + 'px';
      image.style.left = ((boxWidth - renderedWidth) / 2) + 'px';
      image.style.top = ((boxHeight - renderedHeight) / 2) + 'px';
      one('[data-property-view-position]', root).value = 'Horizontal 50%, Vertical 50%';
      one('[data-property-crop-x]', root).value = '0.500000';
      one('[data-property-crop-y]', root).value = '0.500000';
    });
  });

  function closeConfirmation() {
    if (!confirmation) return;
    confirmation.hidden = true;
    document.body.classList.remove('sign-confirm-open');
    confirmationAccepted = false;
    preparedProofFiles = null;
    preparingProofsPromise = null;
    if (confirmationObjectUrl) {
      URL.revokeObjectURL(confirmationObjectUrl);
      confirmationObjectUrl = '';
    }
  }

  /* Every file the order needs, in one place.

     [0] is the customer's watermarked proof and [1] the clear file shown on the
     confirmation and saved for production. A split order adds one clear file
     per panel after those two, each carrying its own finished size. The whole
     set is cut from the largest copy of the picture, fetched first. */
  function prepareOrderFiles() {
    var size = dimensions();
    /* Shopify receives every line-item file in one multipart request. Keep the
       original customer artwork untouched, but make the generated guides
       compact enough that they do not push an otherwise valid upload over the
       request limit. The original file remains the production source. */
    var hasOriginalUpload = uploadEnabled && uploadedFile && uploadedFile.size;
    return loadPrintImage().then(function () {
      if (size.panelCount === 1) {
        return Promise.all([
          createCroppedPreviewFile({ maxSide: 520, quality: .54, watermark: true, fileLabel: 'customer-proof' }),
          createCroppedPreviewFile({
            maxSide: hasOriginalUpload ? 1800 : 2800,
            quality: hasOriginalUpload ? .84 : .91,
            watermark: false,
            fileLabel: 'clear-production-crop'
          })
        ]);
      }
      var overviewMaxSide = hasOriginalUpload ? 1600 : 2200;
      var panelMaxSide = hasOriginalUpload ? 1500 : 2100;
      var jobs = [
        createPanelOverviewFile({ maxSide: 720, quality: .54, watermark: true, cutMarks: true, gapInches: 0, fileLabel: 'customer-proof' }),
        createPanelOverviewFile({
          maxSide: overviewMaxSide,
          quality: hasOriginalUpload ? .82 : .88,
          watermark: false,
          cutMarks: true,
          gapInches: 0,
          fileLabel: 'clear-production-overview'
        })
      ];
      size.panels.forEach(function (panel, index) {
        jobs.push(createPanelProductionFile(index, {
          maxSide: panelMaxSide,
          quality: hasOriginalUpload ? .82 : .87
        }));
      });
      return Promise.all(jobs);
    });
  }

  function shopifyArtworkUploadError(response) {
    return response.text().then(function (body) {
      var detail = '';
      try {
        var json = JSON.parse(body);
        detail = json.description || json.message || (json.errors && JSON.stringify(json.errors)) || '';
      } catch (notJson) {
        detail = String(body || '').replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
      }
      if (response.status === 413) {
        throw new Error('The complete artwork package is too large for Shopify. Please upload a JPG or PDF below 18 MB and try again.');
      }
      if (response.status === 429) {
        throw new Error('Shopify is receiving too many requests. Please wait a moment and try again.');
      }
      if (detail && detail.length < 240) {
        throw new Error('Shopify could not save the artwork: ' + detail);
      }
      throw new Error('Shopify could not store the uploaded artwork (error ' + response.status + '). Please try again.');
    });
  }

  function showConfirmation() {
    /* Prepare the two files needed by Shopify before the customer confirms.
       The clear production crop also serves as the large confirmation image,
       avoiding a third canvas render and removing the post-confirmation wait. */
    preparingProofsPromise = prepareOrderFiles();
    preparingProofsPromise
      .then(function (proofFiles) {
        preparedProofFiles = proofFiles;
        preparingProofsPromise = null;
        if (confirmationObjectUrl) URL.revokeObjectURL(confirmationObjectUrl);
        confirmationObjectUrl = URL.createObjectURL(proofFiles[1]);
        confirmationImage.src = confirmationObjectUrl;
        var variantTitle = (root.getAttribute('data-variant-title') || '').toLowerCase();
        var hasWords = variantTitle.indexOf('with words') !== -1 && variantTitle.indexOf('without words') === -1;
        confirmationMessage.textContent = hasWords
          ? 'Please confirm that the picture is centered and the wording appears exactly the way you want it.'
          : 'Please confirm that the picture is centered exactly the way you want it.';
        var size = dimensions();
        var unitName = activeSizeUnit === 'feet' ? 'feet' : 'inches';
        var toUnit = function (inches) {
          return cleanNumber(activeSizeUnit === 'feet' ? inches / 12 : inches);
        };
        var grommetOption = grommets.options[grommets.selectedIndex];
        var confirmationPrice = calculatedPrice();
        var grommetLine = !grommetOption || grommetOption.getAttribute('data-mode') === 'none'
          ? 'Grommets: No grommets'
          : 'Grommets: ' + grommetOption.textContent.trim() + ' • Count: ' + confirmationPrice.grommetCount;

        /* Every sign is listed on its own line, so nobody confirms four signs
           knowing only the total across them. */
        confirmationMeasurements.replaceChildren();
        function measurementLine(text, strong) {
          var line = document.createElement('div');
          line.className = strong ? 'sign-confirm__measure is-total' : 'sign-confirm__measure';
          line.textContent = text;
          confirmationMeasurements.appendChild(line);
        }
        if (size.panelCount === 1) {
          measurementLine('Finished size: ' + toUnit(size.width) + ' × ' + toUnit(size.height) + ' ' + unitName, true);
        } else {
          size.panels.forEach(function (panel, index) {
            measurementLine('Sign ' + (index + 1) + ': ' + toUnit(panel.width) + ' × ' + toUnit(panel.height) + ' ' + unitName);
          });
          measurementLine(size.panelCount + ' separate signs · total span ' + toUnit(size.width) + ' ' + unitName, true);
        }
        measurementLine(grommetLine);
        confirmation.hidden = false;
        document.body.classList.add('sign-confirm-open');
        if (confirmationDialog) {
          confirmationDialog.scrollTop = 0;
          confirmationDialog.focus({ preventScroll: true });
        }
      })
      .catch(function (problem) {
        preparedProofFiles = null;
        preparingProofsPromise = null;
        error.textContent = (problem && problem.message) || 'The confirmation preview could not be created. Please try again.';
        error.hidden = false;
      });
  }

  if (confirmation) {
    confirmation.querySelectorAll('[data-sign-confirm-edit]').forEach(function (control) {
      control.addEventListener('click', closeConfirmation);
    });
    var confirmationAccept = one('[data-sign-confirm-accept]', confirmation);
    if (confirmationAccept) confirmationAccept.addEventListener('click', function () {
      confirmationAccepted = true;
      confirmation.hidden = true;
      document.body.classList.remove('sign-confirm-open');
      button.click();
    });
  }

  var grommetHelp = one('[data-grommet-help]', root);
  if (grommetHelp) {
    grommetHelp.addEventListener('click', function (event) {
      event.preventDefault();
      var isOpen = grommetHelp.getAttribute('aria-expanded') === 'true';
      grommetHelp.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
    });
  }

  button.addEventListener('click', function () {
    if (!form || button.disabled) return;
    error.hidden = true;
    var incompletePanel = firstIncompletePanel();
    if (incompletePanel >= 0) {
      error.textContent = 'Please enter the width and height for Panel ' + (incompletePanel + 1) + '.';
      error.hidden = false;
      var incompleteWidth = String(panelWidthInputs[incompletePanel].value || '').trim() === '';
      (incompleteWidth ? panelWidthInputs[incompletePanel] : panelHeightInputs[incompletePanel]).focus();
      return;
    }
    var widthViolation = firstPanelWidthViolation();
    if (widthViolation >= 0) {
      showPanelWidthPopup(widthViolation);
      error.textContent = 'Panel ' + (widthViolation + 1) + ' is wider than the maximum shown above.';
      error.hidden = false;
      panelWidthInputs[widthViolation].focus();
      return;
    }
    if (uploadEnabled && !existingCustomerArtworkUrl && (!uploadInput || !uploadInput.files || !uploadInput.files[0])) {
      error.textContent = 'Please choose the picture you want us to print.';
      error.hidden = false;
      if (uploadInput) uploadInput.focus();
      return;
    }
    if (pdfPreviewLoading) {
      error.textContent = 'Please wait a moment while page 1 of your PDF is prepared.';
      error.hidden = false;
      return;
    }
    if (uploadEnabled && (currentImageQuality === 'Low' || currentImageQuality === 'Fair') && !qualityWarningAccepted) {
      if (qualityWarning) {
        qualityWarning.hidden = false;
        document.body.classList.add('sign-quality-warning-open');
        var warningContinueButton = one('[data-quality-continue]', qualityWarning);
        if (warningContinueButton) warningContinueButton.focus();
      }
      return;
    }
    if (!confirmationAccepted) {
      showConfirmation();
      return;
    }
    confirmationAccepted = false;
    one('[data-property-design-id]', root).value =
      Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8);
    update();
    var original = button.textContent;
    button.disabled = true;
    button.textContent = 'Preparing artwork…';

    var squareFootVariantId = number(root.getAttribute('data-square-foot-variant-id'), 0);
    var grommetVariantId = number(root.getAttribute('data-grommet-variant-id'), 0);
    var cornerGrommetVariantId = number(root.getAttribute('data-corner-grommet-variant-id'), 0);
    var price = calculatedPrice();
    var selectedOption = grommets.options[grommets.selectedIndex];
    var grommetMode = selectedOption ? selectedOption.getAttribute('data-mode') : 'none';
    var formData = new FormData(form);
    var selectedProductVariantId = number(formData.get('id'), 0);
    var properties = {};
    formData.forEach(function (value, key) {
      var match = key.match(/^properties\[(.*)\]$/);
      if (match && !(value instanceof File)) properties[match[1]] = value;
    });
    if (editingOriginalProperties) {
      Object.keys(editingOriginalProperties).forEach(function (key) {
        var generatedFile = key === 'Customer artwork' || key === 'CUSTOMER WATERMARKED PROOF — DO NOT PRINT' ||
          key === '_CLEAR PRODUCTION CROP' || key === '_Download production JPG' || key.indexOf('_CLEAR PANEL ') === 0;
        if (!generatedFile && properties[key] === undefined) properties[key] = editingOriginalProperties[key];
      });
    }
    var designId = properties['_Design ID'];
    properties['_Original product URL'] = root.getAttribute('data-original-product-url') || '';
    var items = [{ id: selectedProductVariantId, quantity: 1, properties: properties }];

    if (!selectedProductVariantId || !squareFootVariantId ||
        (grommetMode === 'corners' && !cornerGrommetVariantId) ||
        (grommetMode !== 'none' && grommetMode !== 'corners' && !grommetVariantId)) {
      error.textContent = 'The selected product variant or Shopify fee products are not available. Make sure the product and fee products are Active and published to the Online Store.';
      error.hidden = false;
      button.disabled = false;
      button.textContent = original;
      return;
    }

    if (price.billedSquareFeet > 0) {
      items.push({
        id: squareFootVariantId,
        quantity: price.billedSquareFeet,
        properties: { '_Design ID': designId, '_Charge type': 'Square feet' }
      });
    }
    if (grommetMode === 'corners') {
      items.push({
        id: cornerGrommetVariantId,
        quantity: dimensions().panelCount,
        properties: { '_Design ID': designId, '_Charge type': 'Four corner grommets' }
      });
    } else if (price.grommetCount > 0) {
      items.push({
        id: grommetVariantId,
        quantity: price.grommetCount,
        properties: { '_Design ID': designId, '_Charge type': 'Grommets' }
      });
    }

    /* Prepare proofs during confirmation; defer fees until files are saved. */
    var feeItems = items.slice(1);
    var deferredPdfFeeItems = feeItems;
    var feeRequest = Promise.resolve(null);
    var proofFilesPromise = preparedProofFiles
      ? Promise.resolve(preparedProofFiles)
      : (preparingProofsPromise || prepareOrderFiles());
    proofFilesPromise
      .then(function (proofFiles) {
        var customerProofFile = proofFiles[0];
        var productionProofFile = proofFiles[1];
        return feeRequest.then(function (response) {
          if (response && !response.ok) return response.json().then(function (json) { throw json; });
          var mainFormData = new FormData(form);
          Object.keys(properties).forEach(function (key) {
            mainFormData.set('properties[' + key + ']', properties[key]);
          });
          if (uploadEnabled) {
            if (uploadedFile && uploadedFile.size) {
              // Explicitly attach the original bytes: do not rely on the file
              // input remaining associated with the form after dialogs move.
              mainFormData.set('properties[Customer artwork]', uploadedFile, uploadedFile.name);
              mainFormData.set('properties[_Original filename]', uploadedFile.name);
              mainFormData.set('properties[_Original file bytes]', String(uploadedFile.size));
              mainFormData.set('properties[_Original upload format]', uploadedFile.type || 'Original file');
            } else if (existingCustomerArtworkUrl) {
              mainFormData.set('properties[Customer artwork]', existingCustomerArtworkUrl);
              mainFormData.set('properties[_Original filename]', editingOriginalProperties['_Original filename'] || 'Original customer artwork');
              mainFormData.set('properties[_Original file bytes]', editingOriginalProperties['_Original file bytes'] || 'Saved with original cart item');
              mainFormData.set('properties[_Original upload format]', editingOriginalProperties['_Original upload format'] || 'Original file');
            } else {
              throw new Error('Please select your original artwork again.');
            }
          }
          var orderSize = dimensions();
          mainFormData.set('properties[Finished measurements]', orderSize.panelCount === 1
            ? properties['Width'] + ' × ' + properties['Height']
            : orderSize.panels.map(function (panel, index) {
                return 'Panel ' + (index + 1) + ': ' + cleanNumber(panel.width) + ' × ' + cleanNumber(panel.height) + ' inches';
              }).join(' | ') + ' | Total span: ' + cleanNumber(orderSize.width) + ' inches');
          mainFormData.set('properties[CUSTOMER WATERMARKED PROOF — DO NOT PRINT]', customerProofFile, customerProofFile.name);
          mainFormData.set('properties[_CLEAR PRODUCTION CROP]', productionProofFile, productionProofFile.name);
          /* A split order also carries one clear file per panel, named with the
             finished size that panel has to be printed at. */
          proofFiles.slice(2).forEach(function (panelFile, index) {
            var panel = orderSize.panels[index];
            if (!panel) return;
            mainFormData.set('properties[_CLEAR PANEL ' + (index + 1) + ' — ' +
              cleanNumber(panel.width) + ' × ' + cleanNumber(panel.height) + ' IN]', panelFile, panelFile.name);
          });
          /* Shopify's AJAX endpoint is the supported FormData destination.
             The former non-.js route could return an HTML redirect instead
             of a cart result, leaving the button apparently stuck. */
          var cartAddAjaxUrl = window.theme.routes.cartAdd.replace(/\.js$/, '') + '.js';
          button.textContent = 'Uploading artwork…';
          return fetch(cartAddAjaxUrl, {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: mainFormData
          });
        });
      })
      .then(function (response) {
        if (!response.ok) return shopifyArtworkUploadError(response);
        button.textContent = 'Verifying artwork…';
        /* Do not trust only the HTTP success response: confirm Shopify returned
           all required file properties before continuing to checkout. */
        return fetch(window.theme.routes.cart + '.js', {
          credentials: 'same-origin',
          headers: { 'Accept': 'application/json' }
        }).then(function (cartResponse) {
          if (!cartResponse.ok) throw new Error('Could not verify the uploaded artwork. Please try again.');
          return cartResponse.json();
        }).then(function (cart) {
          var savedItem = cart.items && cart.items.find(function (cartItem) {
            return cartItem.properties && cartItem.properties['_Design ID'] === designId && !cartItem.properties['_Charge type'];
          });
          var savedProperties = savedItem && savedItem.properties;
          var hasCustomerArtwork = !uploadEnabled || (savedProperties && savedProperties['Customer artwork']);
          var hasCustomerProof = savedProperties && savedProperties['CUSTOMER WATERMARKED PROOF — DO NOT PRINT'];
          var hasProductionCrop = savedProperties && savedProperties['_CLEAR PRODUCTION CROP'];
          if (!hasCustomerArtwork || !hasCustomerProof || !hasProductionCrop) {
            var updates = {};
            cart.items.forEach(function (entry) {
              if (entry.properties && entry.properties['_Design ID'] === designId) updates[entry.key] = 0;
            });
            return fetch(window.theme.routes.cartUpdate + '.js', {
              method: 'POST', credentials: 'same-origin',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ updates: updates })
            }).then(function (cleanup) {
              if (!cleanup.ok) throw new Error('Artwork upload failed. Remove the incomplete sign from your cart before trying again.');
              throw new Error('The original artwork or crop was not saved. The incomplete sign was removed. Please try again.');
            });
          }
          // Keep every existing property, including the original file URL.
          var downloadUrl = new URL(root.getAttribute('data-original-product-url'), window.location.origin);
          downloadUrl.search = '?view=production-jpg';
          /* Every clear file the order carries, in panel order, so the download
             page can save the whole set in one go. */
          var downloadParams = new URLSearchParams();
          var panelKeys = Object.keys(savedProperties).filter(function (key) {
            return key.indexOf('_CLEAR PANEL ') === 0;
          }).sort(function (a, b) {
            return parseInt(a.slice(13), 10) - parseInt(b.slice(13), 10);
          });
          if (panelKeys.length) {
            panelKeys.forEach(function (key, index) {
              downloadParams.append('source', savedProperties[key]);
              downloadParams.append('name', 'panel-' + (index + 1) + '-' + designId);
            });
          } else {
            downloadParams.append('source', savedProperties['_CLEAR PRODUCTION CROP']);
            downloadParams.append('name', 'production-crop-' + designId);
          }
          downloadUrl.hash = downloadParams.toString();
          var updatedProperties = Object.assign({}, savedProperties, { '_Download production JPG': downloadUrl.href });
          return fetch(window.theme.routes.cart.replace(/\/$/, '') + '/change.js', {
            method: 'POST', credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: savedItem.key, quantity: savedItem.quantity, properties: updatedProperties })
          }).then(function (response) {
            if (!response.ok) throw new Error('The crop was saved but its JPG download link could not be added. Please check your cart before retrying.');
            return response.json();
          });
        });
      })
      .then(function () {
        /* For a PDF, make sure Shopify safely stores the original file before
           adding its linked fee items. This prevents a failed PDF upload from
           leaving partial charges in the cart. */
        if (!deferredPdfFeeItems.length) return null;
        button.textContent = 'Finishing cart…';
        return fetch(window.theme.routes.cartAdd + '.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Accept': 'application/json', 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items: deferredPdfFeeItems })
        }).then(function (response) {
          if (!response.ok) return response.json().then(function (json) { throw json; });
          return response.json();
        });
      })
      .then(function () {
        return removeOriginalEditedDesign();
      })
      .then(function () {
        if (editingOriginalDesignId) {
          window.sessionStorage.removeItem('creativeSukkahEdit:' + editingOriginalDesignId);
        }
        preparedProofFiles = null;
        preparingProofsPromise = null;
        return fetch(window.theme.routes.cartUpdate + '.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify({ discount: '' })
        });
      })
      .then(function (response) {
        if (!response.ok) return response.json().then(function (json) { throw json; });
        window.location.href = window.theme.routes.cart;
      })
      .catch(function (problem) {
        preparedProofFiles = null;
        preparingProofsPromise = null;
        error.textContent = (problem && (problem.description || problem.message)) || 'The customized sign could not be added. Please try again.';
        error.hidden = false;
        button.disabled = false;
        button.textContent = original;
      });
  });

  if (qualityWarning) {
    function closeQualityWarning() {
      qualityWarning.hidden = true;
      document.body.classList.remove('sign-quality-warning-open');
    }
    qualityWarning.querySelectorAll('[data-quality-warning-close]').forEach(function (control) {
      control.addEventListener('click', closeQualityWarning);
    });
    var uploadBetterButton = one('[data-quality-upload-better]', qualityWarning);
    var continueQualityButton = one('[data-quality-continue]', qualityWarning);
    if (uploadBetterButton) uploadBetterButton.addEventListener('click', function () {
      closeQualityWarning();
      if (uploadInput) uploadInput.focus();
    });
    if (continueQualityButton) continueQualityButton.addEventListener('click', function () {
      qualityWarningAccepted = true;
      closeQualityWarning();
      button.click();
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !qualityWarning.hidden) closeQualityWarning();
    });
  }

  /* Resize handling: run at most once per animation frame, ignore events that
     did not really change the usable area, and ignore the small height-only
     changes phones fire when the address bar slides in and out. Without this
     the redraw could re-trigger itself and hang the tab — most visibly right
     after switching the size unit to feet. */
  window.addEventListener('resize', function () {
    var widthChanged = Math.abs(window.innerWidth - lastWindowWidth) > 1;
    var heightChanged = Math.abs(window.innerHeight - lastWindowHeight) > 120;
    if (!widthChanged && !heightChanged) return;
    lastWindowWidth = window.innerWidth;
    lastWindowHeight = window.innerHeight;
    stableWindowHeight = window.innerHeight;
    if (resizeFrame) return;
    var schedule = window.requestAnimationFrame
      ? function (task) { return window.requestAnimationFrame(task); }
      : function (task) { return window.setTimeout(task, 16); };
    resizeFrame = schedule(function () {
      resizeFrame = 0;
      lastViewportWidth = 0;
      lastViewportHeight = 0;
      update();
    });
  });

  if (image.complete && image.naturalWidth && image.naturalHeight) {
    applyPanelLimits();
    update();
  } else {
    image.addEventListener('load', function () {
      applyPanelLimits();
      update();
    });
  }
  update();
})();
